{
    "Api tokens": {
        "add token": "Додати токен",
        "description": "Генерує API-токен для завантаження файлів OEM для TCT і Configurator або API-токен для використання додатком при запиті FOTA WEB-сервісів. Документацію API можна знайти <1>тут</1>.",
        "example": "Наприклад: fota_token",
        "generate token": "Генерувати токен",
        "generated token": "Створений токен",
        "last used at": "Останнє використання",
        "name": "Назва токена",
        "never": "Ніколи",
        "no tokens": "Токени недоступні",
        "no tokens description": "Після додавання токенів вони будуть перелічені нижче",
        "show token list": "Показати список токенів",
        "titles": {
            "Integration": {
                "description": "Використовується для інтеграції FOTA WEB у вашу систему",
                "name": "Токен інтеграції API"
            },
            "Tct": {
                "description": "Використовується для завантаження файлів OEM для TCT та Configurator",
                "name": "Токен TCT"
            }
        },
        "tokens": "Токени API",
        "token type": "Тип токена",
        "token was created": "Токен успішно створено"
    },
    "Attributes": {
        "Completed": "Завершено",
        "Count": "Підрахувати",
        "Current": "Поточний",
        "Date": "Дата",
        "Empty": "Порожня",
        "excluded files": "Виключені файли (samegrade)",
        "Failed": "Не вдалося",
        "false": "",
        "Feature": "Функція",
        "file size bytes": "Загальний розмір файлів",
        "File_type": "Тип файлу",
        "File_version": "Версія файлу",
        "Fingerprint_id": "Ідентифікація за відбитками пальців",
        "Firmware_date": "Дата прошивки",
        "Firmware_version": "Ревізія",
        "included files": "Включені файли",
        "Include_j1939": "",
        "Message": "Повідомлення",
        "Metadata": "",
        "newest": "З найновіших",
        "oldest": "Від найстарішого",
        "Order": "Замовити",
        "Password_source": "",
        "Pending": "В очікуванні",
        "Period": "Період",
        "Process_id": "",
        "Protocol_id": "Ідентифікатор протоколу",
        "Reported_count": "",
        "Requested_count": "",
        "specific": "Специфічна",
        "Start": "Почати",
        "SystemGenerated": "",
        "true": "",
        "txFwBundleFileTypes": {
            "fw_bundle_ble": "Прошивка BLE",
            "fw_bundle_ble_dtb": "BLE DTB",
            "fw_bundle_can": "Прошивка CAN",
            "fw_bundle_can_dtb": "CAN DTB",
            "fw_bundle_dtb": "TAPP DTB",
            "fw_bundle_mainfw": "Прошивка TAPP"
        },
        "UserEntered": "",
        "vehicle": "Транспортний засіб",
        "Vehicle_id": "Ідентифікатор транспортного засобу",
        "Vin": "VIN"
    },
    "Auth": {
        "account verification": {
            "check autheticator": "Перевірте свою програму-аутентифікатор",
            "check email": "Перевірте свою електронну пошту",
            "code required": "Необхідний код підтвердження.",
            "code sent to email": "Код надіслано на вашу електронну адресу",
            "code valid": "Код дійсний протягом декількох хвилин.",
            "enter code below": "Введіть код нижче, щоб увійти.",
            "no access to otp": "",
            "recovery code": {
                "banner text": "",
                "description": "",
                "secondary text": "",
                "title": ""
            },
            "title": "",
            "use recovery code": ""
        },
        "account verification description": "Потрібен код підтвердження. Перевірте свою програму-аутентифікатор і введіть код нижче, щоб увійти.",
        "check email": "Перевірте свою поштову скриньку та натисніть на отримане посилання, щоб скинути пароль.",
        "community forum": "Форум для підтримки спільноти",
        "contact us": "Зв'яжіться з нами",
        "create initial password": "Створити пароль",
        "create password": "Створіть пароль, який",
        "did not receive": "Не отримали посилання?",
        "do not have account": "Ще не маєте облікового запису?",
        "email": "Електронна пошта",
        "enter email": "Введіть свою зареєстровану електронну адресу нижче, щоб отримати інструкції щодо зміни пароля.",
        "forgot password": "Забули пароль?",
        "forgot your password": "Забули пароль?",
        "for ms365": "Для користувачів Teltonika MS365",
        "invalid email format": "Неправильний формат електронної адреси",
        "invalid password format": "Неправильний формат пароля",
        "link sent": "Посилання надіслано!",
        "length": "Мінімум 8 символів",
        "lowercase": "Містить щонайменше 1 малу літеру",
        "new password": "Новий пароль",
        "password": "Пароль",
        "passwords do not match": "Паролі не збігаються",
        "privacy policy": "Використовуючи FOTA WEB, ви погоджуєтеся з нашою <1>Політикою конфіденційності</1>.",
        "remember password": "Ви пам'ятаєте свій пароль?",
        "repeat password": "Повторіть пароль",
        "required": "Необхідно",
        "resend": "Повторно надіслати",
        "reset password": "Скинути пароль",
        "send reset link": "Надіслати посилання для скидання налаштувань",
        "sign in": "Увійти",
        "sign in to fota": "Увійдіть у свій обліковий запис FOTA WEB",
        "signup": "Зареєструватися",
        "sso": "Увійдіть за допомогою Microsoft",
        "teltonika telematics": "Teltonika Telematics",
        "uppercase": "Велика літера",
        "user consent text": "Я розумію та приймаю <1>Умови надання послуг</1> Teltonika та <2>Угоду про обробку даних</2>.",
        "welcome": "Ласкаво просимо до",
        "wiki": "Вікі-база знань з телематики"
    },
    "Banner": {
        "activate banner": "",
        "apply link": "",
        "banner importance": "",
        "bold": "",
        "close link": "",
        "info": "",
        "italic": "",
        "link": "",
        "message": "",
        "text": "",
        "underline": "",
        "url": "",
        "warning": ""
    },
    "Button": {
        "accept": "Прийняти",
        "accept all": "Прийняти все",
        "accept selected": "Прийняти вибране",
        "actions": "Дії",
        "add": "Додати",
        "add device": "Додати пристрій",
        "add more files": "Додати більше файлів",
        "add new": "Додати новий",
        "agree": "Я згоден",
        "all companies": "Всі компанії",
        "all of company": "Все {{companyName}}",
        "all rows selected": {
            "devices": "Вибрано всі {{count}} пристрої",
            "tasks": "Вибрано всі {{count}} очікуючих/виконуваних завдань",
            "groups": "Вибрано всі {{count}} групи",
            "files": "Вибрано всі {{count}} файли",
            "companies": "Вибрано всі {{count}} компанії",
            "users": "Вибрано всі {{count}} користувачів"
        },
        "approve": "Затвердити",
        "assign": "Призначити",
        "assigning": "Призначення",
        "auto sync": "",
        "back": "Назад",
        "back to sign in": "Назад до входу",
        "cancel": "Скасувати",
        "cancelling": "Скасування",
        "cancel all tasks in group": "Скасувати всі завдання в групі",
        "cancel tasks": "Скасування завдань",
        "cannot create desktop licenses": "Ліцензії не можуть бути створені для внутрішніх компаній.",
        "cannot create offline licenses": "Для необмежених ліцензій не можна створювати офлайн-ліцензії.",
        "change": "Змінити",
        "clear all": "Очистити все",
        "clear all filters": "Очистити всі фільтри",
        "close": "Закрити",
        "company settings": "Налаштування компанії",
        "confirm": "Підтвердити",
        "continue": "Продовжити",
        "copied": "Скопійовано",
        "copy all": "",
        "copy to clipboard": "Копіювати в буфер обміну",
        "create": "Створити",
        "create role": "Створити роль",
        "create task": "Створити завдання",
        "creating": "Створення",
        "default view": "Вигляд за замовчуванням",
        "delete": "Видалити",
        "deleting": "Видалення",
        "deselect all": "Скасувати вибір усіх",
        "device": "Пристрій",
        "disable": "Вимкнути",
        "disagree": "Я не згоден",
        "discard": "Відхилити",
        "download": "",
        "edit": "Редагувати",
        "enable": "Увімкнути",
        "export": "Експорт",
        "exporting": "Експорт",
        "filters": "Фільтри",
        "finish": "",
        "find tool": "Знайти інструмент",
        "first page": "Перша сторінка",
        "generate": "Генерувати",
        "generate codes": "",
        "go back": "Назад",
        "import": "Імпорт",
        "importing": "Імпорт",
        "invite": "Запросити",
        "invite user": "Запросити користувача",
        "invite user to internal disabled": "Тільки адміністратор та користувачі з вищим рівнем доступу можуть запрошувати користувачів до внутрішніх компаній.",
        "language": "Мова",
        "last page": "Остання сторінка",
        "logout": "Вийти",
        "maximize details": "Максимізуйте деталі",
        "merge": "Об'єднати",
        "merging": "Об'єднання",
        "minimize details": "Мінімізуйте деталі",
        "more actions": "Більше дій",
        "more filters": "Більше фільтрів",
        "more options": "Більше опцій",
        "move": "Перемістити",
        "moving": "Переміщення",
        "next": "Далі",
        "next month": "Наступного місяця",
        "next page": "Наступна сторінка",
        "no actions available": "Дії недоступні",
        "no permission": "Вам потрібно дозвіл «{{permissionName}}».",
        "no permissions": "Вам потрібні такі дозволи: {{permissionNames}}.",
        "notify when done": "Повідомити мене, коли буде готово",
        "number of selected companies": "{{companyCount}} з {{companyName}}",
        "only essential": "Тільки найнеобхідніше",
        "open fota web": "Відкрити FOTA WEB",
        "pages of": "з {{total}}",
        "previous month": "Попередній місяць",
        "previous page": "Попередня сторінка",
        "print": "",
        "receive devices": "Отримання пристроїв",
        "refresh page": "Оновити",
        "reject all": "Відхилити все",
        "reset to default": "Скинути до заводських налаштувань",
        "retry failed tasks": "Повторна спроба виконання невдалих завдань",
        "retrying": "Повторна спроба",
        "return home": "Повернемося додому",
        "revert manual level change": "Скасування ручної зміни рівня",
        "rows count per page": "Кількість рядків на сторінці",
        "rows selected": "{{count}} Вибрано",
        "save": "Зберегти",
        "saving": "",
        "see all": "Переглянути все",
        "select all": {
            "devices": "Вибрати всі {{count}} пристрої",
            "tasks": "Вибрати всі {{count}} очікувані/виконувані завдання",
            "groups": "Вибрати всі {{count}} групи",
            "files": "Вибрати всі {{count}} файли",
            "companies": "Вибрати всі {{count}} компанії",
            "users": "Вибрати всіх {{count}} користувачів"
        },
        "select columns to show": "Виберіть стовпці для відображення",
        "selected page is first": "Вибрана сторінка є першою",
        "selected page is last": "Вибрана сторінка є останньою",
        "select rows": "Вибрати рядки",
        "send code": "Надіслати код",
        "settings": "Налаштування",
        "show me": "Показати",
        "show more": "Показати більше",
        "synchronize": "Синхронізація",
        "table statistics": "Статистика таблиць",
        "table view": "Табличний вигляд",
        "transfer": "Передача",
        "transferring": "Передача",
        "transfer my devices": "Перенести мої пристрої",
        "undo": "Скасувати",
        "upload": "Завантаження",
        "upload file": "Завантажити новий файл",
        "user": "Користувач",
        "verify": "Перевірити",
        "yes": "Так"
    },
    "Cookies": {
        "always active": "Завжди активна",
        "analytics cookies": "Аналітичні файли cookie",
        "analytics cookies description": "Ці трекери використовуються для аналітики, щоб допомогти зібрати дані, які дозволяють нам зрозуміти, як користувачі взаємодіють з нашими веб-сайтами. Ці відомості дозволяють нам як поліпшити контент, так і створити кращі функції, що покращують досвід користувача. Цю категорію файлів cookie можна вимкнути.",
        "cookie banner message": "Ми та обрані треті сторони використовуємо файли cookie або подібні технології для технічних цілей та, за вашою згодою, для інших цілей, зазначених у ",
        "cookie modal title": "Ми використовуємо файли cookie",
        "cookie policy": "політика щодо файлів cookie",
        "essential cookies": "Необхідні файли cookie",
        "essential cookies description": "Ці трекери використовуються для дій, які є строго необхідними для функціонування або надання послуги, яку ви у нас замовляли, і ці файли cookie не збирають інформацію про вас, яка може бути використана в маркетингових цілях, і не запам'ятовують, де ви були в Інтернеті. Цю категорію файлів cookie неможливо вимкнути."
    },
    "Dashboard": {
        "company level": {
            "description": {
                "Basic": "Необхідні елементи для віддаленого оновлення пристроїв",
                "Standard": "Розширена автоматизація та інтеграція",
                "Premium": "Масштабування для підприємств та ранній доступ до оновлень"
            },
            "resource limit types": {
                "Companies": "Компанії",
                "Users": "Користувачі",
                "ConfigurationFiles": "Файли конфігурації"
            }
        },
        "empty state": {
            "description": {
                "configurations": "Як тільки FOTA WEB виявить конфігурації, ви зможете переглянути їх список тут.",
                "firmware versions": "Як тільки версії прошивки будуть виявлені FOTA WEB, ви зможете переглянути їх список тут."
            },
            "title": {
                "configurations": "Не виявлено жодних конфігурацій",
                "firmware versions": "Версії прошивки не виявлено",
                "news": "Немає новин для показу"
            }
        },
        "imported activated devices": {
            "days": {
                "1": "Сьогодні",
                "7": "7 днів",
                "30": "30 днів",
                "90": "90 днів"
            },
            "period": "Період"
        },
        "new": "",
        "news": {
            "body": {
                "1": "Нагадуємо, що для користувачів, запрошених після 7 січня 2025 року, 2FA буде обов'язковою відразу після активації облікового запису. Двофакторна автентифікація доступна через підтвердження електронної пошти або додаток-автентифікатор.",
                "2": "Хочемо повідомити вас про планове технічне обслуговування FOTA WEB, яке відбудеться 3 червня 2025 року, починаючи з 05:00 UTC. Зверніть увагу, що під час технічного обслуговування всі послуги будуть недоступні, включаючи користувацький інтерфейс, доступ до API, виконання завдань, OBD та CAN-послуги. Орієнтовний час недоступності послуг — 1 година.",
                "3": "<section><p>Ми раді повідомити про важливе вдосконалення функції Device Unlocker на FOTA WEB:</p></section> <section><p>Тепер усі користувачі можуть безпосередньо розблоковувати пристрої — не потрібно звертатися до технічної підтримки через Helpdesk!</p> <p>Основні деталі:</p> <ul><li>Користувачі можуть розблокувати один і той самий пристрій до 3 разів протягом 24 годин.</li> <li>Після досягнення ліміту опція розблокування буде тимчасово вимкнена на 24 години. </li> <li>Якщо ліміт розблокування перевищено, з'явиться повідомлення про помилку. Це оновлення значно скорочує час очікування та надає вам більше контролю над управлінням вашим автопарком. </li></ul></section> <section><a>Дізнайтеся, як користуватися цією функцією</a></section>",
                "4": "<section><p>Ми раді оголосити про кілька чудових нових оновлень панелі управління FOTA WEB! Ми працювали над поліпшенням вашого досвіду за допомогою вдосконалених віджетів і нових аналітичних даних. </p></section> <section><h3>Нова статистика пристроїв</h3> <p>Отримайте кращий огляд активності ваших пристроїв за допомогою двох нових віджетів:</p> <p><strong>Активовані пристрої</strong>: Ця нова статистика показує, скільки пристроїв було активовано (підключено) за різні періоди: сьогодні, 7 днів, 30 днів або 90 днів. </p> <p><strong>Імпортовані пристрої</strong>: Аналогічно, нова статистика «Імпортовані пристрої» відстежує, скільки пристроїв було імпортовано за сьогодні, 7 днів, 30 днів або 90 днів.</p> </section> <section><h3>Представляємо віджет «Завдання»</h3> <p>Відстежуйте свої операції за допомогою нового віджета «Завдання»:</p> <p><strong>Завдання в черзі</strong>: перегляньте чітку кількість ваших поточних завдань, що очікують на виконання.</p> <p><strong>Огляд завдань</strong>: отримайте розбивку розподілу завдань за періодом (7 днів, 30 днів або 90 днів) і статусом. Сюди входять завдання, які є завершеними, завершеними з помилками або невдалими.</p></section> <section><h3>Більш розумні огляди прошивки та конфігурації</h3> <p>Ми вдосконалили віджети версій прошивки та конфігурацій:</p> <ul><li>Ми видалили статистику «Невідомо» для більшої чіткості даних. </li> <li>Тепер інтерфейс користувача чіткіше показує назви прошивки та конфігурації, а також їх кількість.</li> <li>Спочатку ви побачите 5 найпопулярніших версій або конфігурацій, а також опцію «Показати більше», щоб переглянути до 100 різних записів. </li> <li>Наведення курсору та натискання на конкретне програмне забезпечення або конфігурацію переведе вас на «Сторінку пристроїв» і застосує фільтр.</li></ul></section> <section><h3>Вдосконалений віджет новин</h3> <p>Будьте в курсі подій одним поглядом! Віджет новин має новий вигляд, і тепер ви також можете натиснути на будь-яку новину, щоб прочитати повну інформацію. </p></section> <section><h3>Вдосконалений стан пристрою</h3> <p>Віджет стану пристрою був візуально оновлений для більшої чіткості. Крім того, тепер ви можете навести курсор на стан пристрою і натиснути на нього, щоб відфільтрувати пристрої з відповідним станом на сторінці «Пристрої».</p></section> <section><p>Ми сподіваємося, що ці оновлення полегшать ваші щоденні завдання та нададуть вам більше цінної інформації. Поділіться з нами своєю думкою!</p></section>",
                "5": "<section><h3>Заплановані зміни API</h3></section> <section><p>24 вересня 2025 року ми видалимо поле «роль» з відповідей, що повертають об'єкт користувача (наприклад, кінцеві точки GET /users або GET /users/{userId}). Ця зміна вноситься з метою створення більш надійної та гнучкої системи дозволів у FOTA WEB.</p></section> <section><h3>Попередній перегляд: ролі та дозволи</h3></section> <section><p>Ми усвідомлюємо, що поточна система ролей не забезпечує необхідної гнучкості. Наша команда розробників наполегливо працює над новою функцією <strong>управління ролями та дозволами</strong>, яка дозволить вам створювати ролі з деталізованим контролем дозволів.</p></section> <section><p>Ця нова система надасть вам можливість призначати статичні ролі користувачам або налаштовувати дозволи відповідно до ваших конкретних потреб, а також створювати власні ролі. Ми дуже раді цій новій функції і з нетерпінням чекаємо на можливість поділитися з вами більш детальною інформацією про управління ролями та дозволами, коли вона стане доступною.</p></section>",
                "6": "<section><p>Ми раді оголосити про випуск нової функції <strong>«Ролі та дозволи»</strong>, призначеної для точного контролю доступу користувачів у FOTA WEB. Ця функція дозволяє визначати можливості користувачів за допомогою <strong>ролей</strong>, які є наборами конкретних <strong>дозволів</strong> (наприклад, «Створити завдання», «Запросити користувача»). Функція включає незмінні <strong>Статичні ролі</strong> — Адміністратор, Користувач і Гість — для базової безпеки, а також настроювані <strong>Настроювані ролі</strong>, які можуть створювати або редагувати тільки користувачі <strong>Преміум-рівня компанії</strong>. Дозволи тепер класифіковані за ключовими областями, такими як Пристрої, Завдання та Користувачі, і їх можна переглянути, навівши курсор на «Кількість дозволів» у розділі управління. <strong>Усім існуючим користувачам, створеним до цього оновлення, автоматично присвоєно роль «Адміністратор», що гарантує їм збереження повного набору дій, які вони могли виконувати раніше. </strong></p></section> <section><p>Це оновлення забезпечує кращу безпеку та розподіл навантаження. Ролі тепер є специфічними для компанії і не можуть бути успадковані в інших структурах компанії. Зверніть увагу, що роль завжди повинна бути призначена при запрошенні або переміщенні користувача в компанію, а ролі з активними призначеннями користувачів не можуть бути видалені. Тепер ви можете використовувати <strong>новий фільтр «Роль»</strong> на сторінці <strong>Користувачі</strong> для більш зручного управління. Ознайомтеся з розділом «Ролі та дозволи» вже сьогодні, щоб налаштувати доступ відповідно до потреб вашої організації.</p></section> <section><p>Детальний посібник з управління користувачами та ролями можна знайти на <a>вікі-сторінці</a>.</p></section>",
                "7": "<section><p>Ми раді представити новий потужний спосіб управління вашими завданнями за допомогою функції <strong>Розклад за датою</strong>, яка забезпечує більшу точність у виконанні термінових завдань!</p></section> <section><h3>Основні особливості</h3></section> <section><ul><li><strong>Конкретні терміни</strong> - Тепер ви можете планувати завдання на <strong>конкретну дату або інтервал дат</strong> за допомогою нової опції «Планування за датою».</li> <li><strong>Звична поведінка залишилася незмінною</strong> — звична функція <strong>Планування за часом</strong> залишається повністю доступною. </li> <li><strong>Статус закінчення терміну</strong> — завдання, які не були виконані до встановленої дати, тепер автоматично змінюють статус на <strong>Закінчився термін</strong>, супроводжуючись повідомленням: <strong>«Завдання не було виконано протягом встановленого терміну».</strong></li> <li><strong>Орієнтований на користувача час</strong> — всі розклади створюються на основі <strong>вашого місцевого часу</strong>.</li></ul></section> <section><h3>Як це працює</h3></section> <section><p>При встановленні завдання <strong>«Розклад за датою»</strong>:</p> <ul><li>Ви оберете <strong>«Дату початку»</strong> та <strong>«Дату закінчення»</strong> за допомогою компонента вибору дати.</li> <li>Компонент вибору дати враховує термін дії завдання на рівні компанії.</li></ul></section><section><p>Функція <strong>Планування за датою</strong> наразі доступна виключно для вищих рівнів компанії і недоступна для рівня <strong>Базовий</strong>.</p></section>",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            },
            "title": {
                "1": "Обов'язкова двофакторна аутентифікація (2FA) для нових користувачів, починаючи з 7 січня 2025 року",
                "2": "Планове технічне обслуговування 3 червня 2025 року",
                "3": "Нова функція: простіше розблокування пристроїв для всіх користувачів",
                "4": "Дізнайтеся, що нового на вашій панелі інструментів!",
                "5": "Важливо: майбутні зміни API та попередній огляд ролей і дозволів",
                "6": "Нова функція вже доступна: розширений контроль за допомогою «Ролей та дозволів»",
                "7": "Нова функція: більша гнучкість завдяки плануванню завдань за датою",
                "8": "",
                "9": "",
                "10": "",
                "11": "",
                "12": "",
                "13": ""
            }
        },
        "published": "Опубліковано",
        "take me there": "Перейти туди",
        "tasks": {
            "current": "Поточний",
            "status": {
                "completed": "Завершено",
                "completed_with_errors": "Завершено з помилками",
                "failed": "Не вдалося",
                "no tasks": "Без завдань"
            },
            "task_type_counts_7_days": {
                "progressBarTitle": "7 днів",
                "tooltipTitle": "Останні 7 днів"
            },
            "task_type_counts_30_days": {
                "progressBarTitle": "30 днів",
                "tooltipTitle": "Останні 30 днів"
            },
            "task_type_counts_90_days": {
                "progressBarTitle": "90 днів",
                "tooltipTitle": "Останні 90 днів"
            }
        },
        "title": {
            "activated": "Активовані пристрої",
            "configurations": "Конфігурації",
            "device status": "Стан пристрою",
            "firmware versions": "Версії прошивки",
            "imported": "Імпортовані пристрої",
            "news": "Новини",
            "queued tasks": "Завдання в черзі",
            "refreshed every hour": "Оновлюється щогодини",
            "resource limits": "Обмеження ресурсів",
            "task overview": "Огляд завдань",
            "tasks": "Завдання"
        },
        "tooltips": {
            "activated": "Кількість пристроїв, які вперше підключилися до FOTA WEB протягом вибраного періоду (сьогодні, останні 7 днів, останні 30 днів, останні 90 днів).",
            "configurations": "Показує розподіл імен конфігураційних файлів, які були завантажені на ваші пристрої. Показується до 100 унікальних імен файлів.",
            "firmware versions": "Відображає розподіл версій прошивки, про які повідомляють підключені пристрої. Відображається до 100 унікальних версій.",
            "imported": "Кількість пристроїв, доданих до вашого облікового запису протягом вибраного періоду (сьогодні, останні 7 днів, останні 30 днів, останні 90 днів)."
        }
    },
    "Date picker": {
        "disableFuture": "Недійсна дата",
        "disablePast": "Недійсна дата",
        "invalidDate": "Недійсна дата",
        "maxDate": "Неправильна дата",
        "minDate": "Неправильна дата",
        "shouldDisableDate": "Недійсна дата",
        "shouldDisableMonth": "Недійсна дата",
        "shouldDisableYear": "Недійсна дата"
    },
    "Device export": {
        "properties": {
            "activity_status": "",
            "bootloader": "",
            "company_name": "",
            "created_at": "",
            "current_configuration": "",
            "current_firmware": "",
            "description": "",
            "group_name": "",
            "gsm_number": "",
            "iccid": "",
            "imei": "",
            "imsi": "",
            "model": "",
            "model_platform": "",
            "modem_version": "",
            "oem_file_vehicle_name": "",
            "product_code": "",
            "seen_at": "",
            "serial": "",
            "task_queue": "",
            "updated_at": "",
            "vin": ""
        },
        "select data": ""
    },
    "Dialog": {
        "access group inheritance": "",
        "add new device": "Додати новий пристрій",
        "add new device description": "Додайте один або кілька нових пристроїв до вибраної компанії та групи. Тільки застарілі пристрої, такі як FM або FMA, необхідно імпортувати, встановивши прапорець «Імпортувати як застарілі пристрої».",
        "add new device legacy title": "Імпорт як застарілі пристрої.",
        "add new device legacy description": "Встановіть «Створено» на 2016.01.01 і «Модель» на Legacy.",
        "add new product code": "Додати новий код продукту",
        "add new product code description": "Додайте новий код продукту пристрою та пов'яжіть його з доступним пакетом CAN.",
        "all permissions": "Всі дозволи",
        "assign access group": "",
        "assign can package description": "Виберіть тип пакета та призначте його всім вибраним пристроям.",
        "assign role": "Призначити роль",
        "attribute value": "Значення атрибуту",
        "auto sync": "",
        "auto sync toggle": {
            "compatibility": {
                "compatible devices": "",
                "selected devices": ""
            },
            "descriptions": {
                "dialog": "",
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "modes": {
                "Disabled": "",
                "Enabled": "",
                "ReportingOnly": ""
            },
            "tooltips": {
                "bluetooth_auth_list_sync": "",
                "disabled submit": "",
                "main_configuration_sync": "",
                "manual_geofence_list_sync": "",
                "one_wire_auth_list_sync": ""
            }
        },
        "begin download": "Почати завантаження",
        "by date": "За датою",
        "by time": "За часом",
        "can adapter": "CAN-адаптер",
        "cancel pending tasks": "Скасування очікуючих завдань одного типу",
        "cancel tasks": "Скасування завдань",
        "cancel tasks in group": {
            "alert title": "Ця дія займе до декількох хвилин.",
            "banner description": "Щоб переглянути оновлений статус завдань, зверніться до деталей групи завдань або оновіть сторінку.",
            "banner title": "Ця дія займе до декількох хвилин, залежно від кількості завдань.",
            "description": "Натискання кнопки «Прийняти» скасує всі очікувані та виконувані завдання. Ви впевнені, що хочете продовжити?",
            "title": "Скасувати всі завдання в групі?"
        },
        "canObd": "CAN/OBD",
        "carrier": "Carrier",
        "clear device history banner": "",
        "client email": "Електронна адреса представника клієнта",
        "companies": "Компанії",
        "company": "Компанія",
        "company level": {
            "Basic": "Базова",
            "Internal": "Внутрішня",
            "Premium": "Преміум",
            "Standard": "Стандартна"
        },
        "company level change description": "Підвищення рівня компанії шляхом вибору нового рівня та надання пояснення причин. Пониження рівня компанії неможливе. Всі дати вказані в часовому поясі UTC.",
        "company level manual revert": {
            "confirmation": {
                "description": "Ця дія поверне рівень компанії до автоматично призначеного рівня «{{companyLevel}}». Ви впевнені, що хочете продовжити?",
                "title": "Скасувати зміну рівня вручну?"
            },
            "description": "Повернення змінить рівень компанії назад на автоматично призначений рівень.",
            "title": "Цей рівень компанії був оновлений вручну до {{expirationDate}}."
        },
        "company level type": "Тип на рівні компанії",
        "company name": "Назва компанії",
        "company statistics": {
            "child companies": "Кількість дочірніх компаній",
            "devices": "Кількість пристроїв",
            "files": "Кількість файлів",
            "groups": "Кількість груп пристроїв",
            "tasks": "Кількість завдань",
            "users": "Кількість користувачів"
        },
        "company type": {
            "All": "",
            "Client": "Клієнт",
            "Internal": "Внутрішня",
            "Virtual": "Віртуальна"
        },
        "configuration": "Конфігурація",
        "confirmations": {
            "are you sure": "Ви впевнені?",
            "are you sure you wish to continue": "Ви впевнені, що хочете продовжити?",
            "assign can package confirmation": "Ви впевнені, що хочете призначити вибраний пакет для вказаної кількості пристроїв?",
            "cancel task confirmation": {
                "first part": "Ви впевнені, що хочете скасувати вказану кількість завдань?",
                "second part": "Якщо так, введіть кількість завдань, яких це стосується, і натисніть «Підтвердити»."
            },
            "create task confirmation": "Ви впевнені, що хочете створити завдання для вказаної кількості пристроїв?",
            "delete resource confirmation": {
                "first part": "Ви впевнені, що хочете видалити вказану кількість {{resource}}?",
                "second part": "Якщо так, введіть кількість уражених {{resource}} і натисніть «Видалити»."
            },
            "delete resources": {
                "companies": "компанії",
                "files": "файли",
                "groups": "групи пристроїв",
                "deviceModels": "моделі",
                "productCodes": "коди продуктів",
                "roles": "ролі",
                "users": "користувачі"
            },
            "description second part": "Якщо так, введіть кількість уражених пристроїв і натисніть «Підтвердити».",
            "export device data confirmation": "Ви впевнені, що хочете експортувати дані для вказаної кількості пристроїв?",
            "file": "Введіть кількість рядків, що містяться у файлі",
            "filter": {
                "companies": "Введіть кількість відфільтрованих компаній",
                "devices": "Введіть кількість відфільтрованих пристроїв",
                "files": "Введіть кількість відфільтрованих файлів",
                "groups": "Введіть кількість відфільтрованих груп пристроїв",
                "productCodes": "Введіть кількість відфільтрованих кодів продуктів",
                "tasks": "Введіть кількість відфільтрованих завдань",
                "users": "Введіть кількість відфільтрованих користувачів"
            },
            "id_list": {
                "companies": "Введіть кількість вибраних компаній",
                "devices": "Введіть кількість вибраних пристроїв",
                "files": "Введіть кількість вибраних файлів",
                "groups": "Введіть кількість вибраних груп пристроїв",
                "productCodes": "Введіть кількість вибраних кодів продуктів",
                "tasks": "Введіть кількість вибраних завдань",
                "users": "Введіть кількість вибраних користувачів"
            },
            "merge companies confirmation": "Ви збираєтеся об'єднати компанії {{sourceCompany}} та {{targetCompany}}.",
            "move companies confirmation": "Ви збираєтеся перенести {{sourceCompany}} до компанії {{targetCompany}}.",
            "move devices confirmation": "Ви впевнені, що хочете перенести вказану кількість пристроїв до іншої компанії?",
            "number of lines": "Кількість рядків",
            "selected 20 or more devices": "Ви вибрали 20 або більше пристроїв...",
            "transfer devices confirmation": "Ви впевнені, що хочете передати вказану кількість пристроїв іншій компанії?"
        },
        "confirm cannot revert": "Ця дія є незворотною.",
        "confirm merge companies": "Ви впевнені, що хочете об'єднати ці компанії?",
        "count": "Підрахувати",
        "create company": "Створити компанію",
        "create company description": "Створіть нову компанію під вибраною материнською компанією.",
        "create desktop license": "Створити ліцензію для desktop комп'ютерів",
        "create desktop license description": "Видайте нову онлайн-ліцензію FOTA Desktop для клієнтської компанії з її IP-адресою, апаратним ключем та терміном дії (максимум 2 роки).",
        "create group": "Створити групу",
        "create group description": "Організуйте пристрої в групи для спрощення управління та масового призначення.",
        "create model": "Створити модель",
        "create model description": "Створіть нову модель пристрою, вказавши назву, платформу та підтримку TCT web.",
        "create offline license": "Створити офлайн-ліцензію",
        "create or edit group description": "Прошивка та конфігурація можуть бути призначені групі. Після цього для всіх членів групи (пристроїв) будуть створені завдання з оновлення прошивки та/або конфігурації.",
        "create role": "Створити роль",
        "create role description": "Створіть нову роль, надавши їй назву та опис, вибравши компанію та призначивши конкретні дозволи.",
        "create smart group": "Створити розумну групу",
        "create smart group banner message": "",
        "create smart group description": "Прошивка та файли конфігурації можуть бути призначені групі для кожної платформи. Після призначення файлів будуть створені завдання оновлення для всіх пристроїв групи.",
        "create task description first step": "Створюйте різноманітні завдання, починаючи від оновлення конфігурації або прошивки до отримання журналів, конфігурації та іншого з вибраних або відфільтрованих пристроїв. Крім того, ви можете планувати створені завдання для вашої зручності.",
        "create task description last step": "Перед створенням завдання переконайтеся, що наведена нижче інформація є правильною.",
        "current level": "поточний рівень",
        "custom resource limits": {
            "at least one limit must be higher": "Принаймні одне обмеження повинно бути вищим за значення рівня Premium за замовчуванням.",
            "configuration files per device": "Конфігураційні файли для кожного пристрою",
            "confirmation modal description": "Ви впевнені, що хочете змінити наступні обмеження ресурсів компанії «{{companyName}}»?",
            "confirmation modal title": "Змінити обмеження ресурсів компанії?",
            "count": {
                "companies count": "Кількість компаній: {{number}}",
                "configuration files per device count": "Кількість конфігураційних файлів на пристрій: {{number}}",
                "tasks per group count": "Кількість завдань на групу: {{number}}",
                "users count": "Кількість користувачів: {{number}}"
            },
            "explanations": {
                "companies": "Загальна кількість дочірніх компаній, які можна створити в ієрархії компанії.",
                "configuration files per device": "Кількість конфігураційних файлів, які можна зберігати: 1 пристрій дорівнює 1 конфігураційному файлу. Мінімальна гарантована кількість конфігураційних файлів становить 100 для кожного рівня компанії.",
                "tasks per group": "Кількість завдань, які можуть бути в одній групі завдань.",
                "users": "Загальна кількість користувачів, яких можна створити в ієрархії компанії."
            },
            "main modal description": "Встановіть індивідуальну кількість ресурсів для різних типів ресурсів, таких як компанії, користувачі, завдання за групами завдань або файли конфігурації. Індивідуальні ресурси будуть активними до закінчення терміну дії преміум-рівня або ручного скидання.",
            "resources limit type": "Тип обмеження ресурсів",
            "revert custom resource limits": "Скасування обмежень на використання ресурсів",
            "revert custom resource limits description": "Скидання всіх обмежень призведе до встановлення стандартних значень ресурсів і зміни рівня компанії на Premium.",
            "revert custom resource limits description confirmation": "Ця дія поверне обмеження ресурсів до автоматично призначених для рівня «Преміум». Ви впевнені, що хочете продовжити?",
            "revert custom resource limits title": "Ресурсні обмеження цієї компанії були встановлені вручну.",
            "revert custom resource limits title confirmation": "Скасувати обмеження на власні ресурси?",
            "tasks per group": "Завдання за групами"
        },
        "date range": "Діапазон дат",
        "date to": "до",
        "delete companies": "Видалити компанії",
        "delete deviceModels": "Видалити моделі",
        "delete files": "Видалення файлів",
        "delete file warning": "Видалення файлів скасовує пов'язані завдання та групи завдань.",
        "delete groups": "Видалити групи пристроїв",
        "delete productCodes": "Видалити коди продуктів",
        "delete roles": "Видалити ролі",
        "delete tasks and history": "",
        "delete users": "Видалення користувачів",
        "description": "Опис",
        "desktop license delete description": "Ви впевнені, що хочете видалити ліцензію для desktop-комп'ютерів «{{name}}»?",
        "desktop license name": "Назва ліцензії для desktop комп'ютерів",
        "device identifier": "Ідентифікатор пристрою",
        "device transfer": {
            "main": {
                "description": "Передача вибраних або відфільтрованих пристроїв до сторонньої компанії за допомогою токена, згенерованого компанією-одержувачем.",
                "title": "Передача пристроїв"
            },
            "receive devices": {
                "copy token": "Скопіюйте та надішліть згенерований токен особі, відповідальній за передачу пристроїв від її компанії до вашої.",
                "description": "Створіть токен пристрою-одержувача та надішліть його компанії-перевізнику.",
                "token info": "Токен є одноразовим і втрачає чинність через 21 день."
            },
            "transfer devices": {
                "confirmation": "Ви впевнені, що хочете перенести пристрої до компанії, вказаної нижче?",
                "device token": "Токен для передачі пристрою необхідно отримати у менеджера компанії, якій ви бажаєте передати свої пристрої.",
                "transfer from file": "Завантажте файл зі списком пристроїв (IMEI), які ви хочете перенести з вашої компанії до компанії, токен якої ви щойно ввели."
            }
        },
        "device transfer token": "Токен передачі пристрою",
        "downgrading company level is not possible": "Пониження рівня компанії неможливе",
        "download sample file message": "Завантажте <1>зразок шаблону CSV</1>, щоб побачити приклад необхідного формату.",
        "edit group banner message": "Зміна прошивки та/або конфігураційних файлів скасує всі попередні завдання того ж типу, що знаходяться в очікуванні.",
        "edit group description": "Змінити налаштування для цієї групи пристроїв.",
        "edit role description": "Налаштуйте назву ролі, опис та дозволи. Призначену компанію змінити неможливо.",
        "edit smart group description": "Прошивка та файли конфігурації можуть бути призначені або змінені для групи для кожної платформи. Після призначення або зміни файлів будуть створені завдання оновлення для всіх пристроїв групи.",
        "email": "Електронна пошта",
        "enter": "Вхід",
        "enter code": "Введіть код",
        "enter description": "Введіть опис",
        "enter name": "Введіть ім'я",
        "example": "Наприклад:",
        "expires at": "Термін дії закінчується",
        "explanation": "Пояснення",
        "export device data": "Експорт даних пристрою",
        "export device description": "",
        "export file format": "Формат файлу експорту",
        "feature": "Функція",
        "feature control": "Контроль функцій",
        "field disabled until company selected": "Це поле недоступне, доки не буде обрано компанію.",
        "firmware": "Прошивка",
        "files to download": "Файли для завантаження",
        "file upload": {
            "banner text": {
                "1_wire_authorization_list": "Завантажений список авторизації 1-Wire буде автоматично відсортований для підвищення швидкості та точності функціонування.",
                "bluetooth_authorization_list": "Завантажений список авторизації Bluetooth буде автоматично відсортований для підвищення швидкості та точності функціонування."
            },
            "endings": {
                "file": "файл",
                "files": "файли"
            },
            "fail": {
                "multiple": "{{failCount}} із {{totalCount}} {{fileEnding}} не було завантажено через помилку.",
                "single": "{{failCount}} із {{totalCount}} {{fileEnding}} не було завантажено через помилку."
            },
            "success": {
                "multiple": "Усі файли успішно додано до вибраних компаній.",
                "single": "Усі файли успішно додано до вибраної компанії."
            }
        },
        "filtered": "Фільтрована",
        "filtered companies": "Відфільтровані компанії",
        "filtered devices": "Фільтровані пристрої",
        "filtered files": "Відфільтровані файли",
        "filtered groups": "Фільтровані групи",
        "filtered tasks": "Фільтровані завдання",
        "filtered users": "Фільтровані користувачі",
        "find tool": {
            "device": {
                "error not valid": "IMEI повинен складатися з 15 символів",
                "error subtitle": "Пристрій не знайдено. Спробуйте ввести інший IMEI.",
                "error title": "Пристрій не знайдено",
                "link": "Перейти до пристрою",
                "no permission": "Ви не маєте дозволу на перегляд цього пристрою."
            },
            "user": {
                "error not valid": "Неправильний формат електронної адреси",
                "error subtitle": "Користувач не знайдений. Спробуйте ввести іншу електронну адресу користувача.",
                "error title": "Користувач не знайдений",
                "link": "Перейти до користувача",
                "no permission": "Ви не маєте дозволу на перегляд цього користувача."
            }
        },
        "firmware date": "Дата прошивки",
        "from form": "З форми",
        "from file": "З файлу",
        "general": "Загальна інформація",
        "gsm_number": "Номер GSM",
        "iccid": "ICCID",
        "imei": "IMEI",
        "imei restriction": "Обмеження IMEI",
        "import device data": "Імпорт даних пристрою",
        "import device data description": "Імпортуйте вибрані атрибути даних для пристроїв із наданого списку.",
        "import device data info": "Кожен атрибут має максимальну кількість символів, яка вказана в дужках. Якщо атрибут містить більше символів, ніж максимально дозволено, він буде автоматично скорочений до максимально дозволеної кількості.",
        "import device data limit": "(максимум {{limit}} символів)",
        "imsi": "IMSI",
        "input text too long": "Текст занадто довгий. Максимально дозволена кількість символів {{maxLength}}.",
        "invalid hardware key": "Неправильний формат апаратного ключа",
        "invalid imei": "IMEI недійсний",
        "invalid ipv4": "Недійсний формат IPv4",
        "invalid serial": "Недійсний серійний номер",
        "invalid value": "Недійсне значення",
        "inverted selection": "Інвертований вибір",
        "invite user": "Запросити користувача",
        "invite user description": "Запросіть нового користувача до вибраної материнської компанії та визначте його роль. Після надсилання запрошення користувач матиме 30 днів, щоб прийняти його, перш ніж воно втратить чинність.",
        "invite user max roles": "Дозволено максимум 5 ролей. Відмітьте одну, щоб продовжити.",
        "log files": "Файли журналів",
        "make": "Створити",
        "manage permissions": "Управління всіма даними на рівні облікового запису та сайту.",
        "maximum value is": "Максимальне значення становить {{value}}",
        "merge companies": "Об'єднання компаній",
        "merge companies info": "Усі ресурси вихідної компанії (пристрої, групи, файли, компанії, користувачі з їхніми ролями) будуть перенесені до цільової компанії. Перед об'єднанням можна переглянути ролі користувачів. Вихідна компанія буде видалена після цього.",
        "merge companies disabled option": {
            "client to internal": "Компанія типу «клієнт» не може бути об'єднана з компанією типу «внутрішня».",
            "internal": "Компанії внутрішнього типу не можуть бути об'єднані.",
            "lz code": "Компанія з кодом не може бути об'єднана."
        },
        "minimum value is": "Мінімальне значення становить {{value}}",
        "move companies disabled option": {
            "internal": "Внутрішній тип компанії не можна перемістити."
        },
        "move device": "Переміщення пристрою",
        "move device description": "Переміщення вибраних або відфільтрованих пристроїв до існуючої компанії та/або групи в ієрархії компанії.",
        "move device group": "",
        "move device group banner": "",
        "move device group description": "",
        "move devices": "Переміщення пристроїв",
        "name": "Назва",
        "newest": "З найновіших",
        "no dropdown files": {
            "description": "Щоб вибрати цей варіант, завантажте новий файл $t(Dialog##no dropdown files##file names##{{fileName}}).",
            "description no permission create file": "",
            "file names": {
                "1_wire_authorization_list": "Список авторизації 1-Wire",
                "adas_firmware": "Прошивка ADAS",
                "ble_fw": "Прошивка BLE",
                "blue_nrg": "Прошивка BlueNrg",
                "bluetooth_authorization_list": "Список авторизації Bluetooth",
                "can_chip_firmware": "Прошивка мікросхеми FM CAN",
                "carrier_advance_firmware": "Прошивка Carrier Advance",
                "carrier_advance_settings": "Carrier Advance налаштування",
                "carrier_apx_firmware": "Прошивка Carrier APX",
                "carrier_apx_settings": "Налаштування Carrier APX",
                "certificate": "Сертифікат TLS",
                "configuration": "конфігурація",
                "dsm_firmware": "Прошивка DSM",
                "dtb": "DTB",
                "firmware": "прошивка",
                "fw_bundle": "пакет прошивок",
                "gnssm_download_assistant": "GNSS-M Download Assistant",
                "gnssm_firmware": "Прошивка GNSS-M",
                "main configuration": "",
                "manual_geofence_list": "Список сценаріїв ручного геофенсінгу",
                "meig_modem_firmware": "Прошивка модему MeiG",
                "netprisma_modem_firmware": "Прошивка модему NETPRISMA",
                "psub": "передплата",
                "quectel_modem_firmware": "Прошивка модему Quectel",
                "simcom_modem_firmware": ""
            },
            "main": "Файлів $t(Dialog##no dropdown files##file names##{{fileName}}) немає."
        },
        "none": "Немає",
        "obd oem": "OBD OEM",
        "offline license delete description": "Ви впевнені, що хочете видалити офлайн-ліцензію «{{name}}»?",
        "oldest": "Від найстарішого",
        "only integers": "Дійсними є тільки цілі числа",
        "only numbers": "Дійсними є тільки цифри",
        "optional": "опціонально",
        "other companies": "Інші компанії",
        "parent company": "Материнська компанія",
        "permission preset": "Попередньо встановлені дозволи",
        "platform compatibility": {
            "banner text": "Деякі з вибраних моделей пристроїв не сумісні з вибраним типом завдання. Цей тип завдання не буде створено за замовчуванням для несумісних моделей пристроїв.",
            "compatible model devices": "Сумісні моделі пристроїв",
            "count text": "Завдання буде створено для <1>{{compatibleCount}}</1> з {{totalCount}} пристроїв.",
            "create tasks for incompatible devices": "Створення завдань для несумісних пристроїв.",
            "devices from file": "Пристрої з файлу",
            "platform": "Платформа {{title}}",
            "task applies": "Завдання застосовується до",
            "task cannot be created": "Неможливо створити завдання для несумісних моделей пристроїв."
        },
        "receiving company": "Ця компанія отримає ваші пристрої",
        "resend user invitation": "",
        "retry tasks in group": {
            "alert title": "Ця дія займе до декількох хвилин.",
            "banner description": "Щоб переглянути оновлений статус завдань, зверніться до деталей групи завдань або оновіть сторінку.",
            "description": "Натискання кнопки «Прийняти» призведе до повторної спроби виконання всіх невдалих завдань. Ви впевнені, що хочете продовжити?",
            "title": "Повторити всі завдання в групі?"
        },
        "revision": "Ревізія",
        "revision value error": "Значення повинно бути двозначним (00 - 99).",
        "role name": "Назва ролі",
        "root company": "Компанія Root",
        "sales email": "Електронна пошта менеджера з продажу",
        "scheduled time warning": "Завдання з запланованим часом не змінюють конфігурацію часу підключення пристрою до FOTA. Завдання будуть виконані, якщо пристрій підключиться до FOTA протягом вибраного часового вікна. Переконайтеся, що пристрої налаштовані на підключення до FOTA WEB протягом періоду, не меншого за вибране часове вікно.",
        "schedule task": "Планування завдань",
        "select": "Вибрати",
        "select at least one": {
            "companies": "Будь ласка, виберіть хоча б одну компанію",
            "devices": "Будь ласка, виберіть хоча б один пристрій",
            "files": "Будь ласка, виберіть хоча б один файл",
            "groups": "Будь ласка, виберіть хоча б одну групу",
            "tasks": "Виберіть хоча б одне завдання",
            "users": "Будь ласка, виберіть хоча б одного користувача"
        },
        "selected": "Вибрано",
        "selected companies": "Вибрані компанії",
        "selected deviceModels": "Вибрані моделі",
        "selected devices": "Вибрані пристрої",
        "selected files": "Вибрані файли",
        "selected groups": "Вибрані групи пристроїв",
        "selected productCodes": "Вибрані коди продуктів",
        "selected roles": "Вибрані ролі",
        "selected tasks": "Вибрані завдання",
        "selected users": "Вибрані користувачі",
        "select company": "",
        "select group": "",
        "select time interval": "Виберіть часовий інтервал",
        "selected time window": "Вибраний часовий проміжок: {{fromDate}} до {{toDate}}",
        "set bluetooth password": {
            "bluetooth password": "",
            "repeat bluetooth password": "",
            "enter password": "",
            "password source": "",
            "rules": {
                "allowed characters": "",
                "characters length": "",
                "passwords must match": ""
            },
            "SystemGenerated": {
                "description": ""
            },
            "UserEntered": {
                "description": ""
            }
        },
        "show files for selected companies only": "",
        "smart group": {
            "description": "Виберіть доступні файли для пристроїв платформи {{platformName}}.",
            "title": "Файли платформи {{platformName}}"
        },
        "sn": "Серійний номер.",
        "specific": "Специфічна",
        "time period": "Період часу",
        "time period custom": "Налаштована",
        "tls certificate transfer info": "",
        "token has expired": "Термін дії токена закінчився",
        "token is valid": "Токен дійсний",
        "transfer companies": "Переміщення компаній",
        "transfer companies description": "Виберіть, чи потрібно перемістити або об'єднати дві компанії. Деякі опції є незворотними.",
        "transfer devices": "Передача пристроїв",
        "tri source": {
            "selected tab description": {
                "create task": "Вибране завдання буде створено для вибраних пристроїв за допомогою прапорця.",
                "general": "Вибрана дія буде виконана для вибраних пристроїв за допомогою прапорця."
            },
            "filtered tab description": {
                "create task": "Вибране завдання буде створено для відфільтрованих пристроїв за допомогою одного або декількох доступних фільтрів.",
                "general": "Вибрана дія буде виконана для відфільтрованих пристроїв за допомогою одного або декількох доступних фільтрів."
            },
            "from file tab description": {
                "create task": "Вибране завдання буде створено для пристроїв, які були вказані у завантаженому файлі.",
                "general": "Вибрана дія буде виконана для пристроїв, які були вказані у завантаженому файлі."
            }
        },
        "unlocker": {
            "generate unlock key": "Створити ключ розблокування",
            "generate unlock key description": "Введіть «Код блокування» пристрою з TCT у поле нижче. Натисніть кнопку «Створити», щоб згенерувати ключ розблокування, і використовуйте його в TCT для розблокування пристрою.",
            "invalid lock code": "Недійсний код блокування пристрою.",
            "limit reached": "Ви досягли максимальної кількості згенерованих ключів розблокування.",
            "lock code": "Код блокування",
            "unlock key": "Ключ розблокування",
            "unlock key success message": "Ключ розблокування успішно згенеровано."
        },
        "upload file": "Завантажити файл",
        "upload file description": "Завантажуйте до {{count}} файлів одночасно, використовуючи поле перетягування або вибираючи їх.",
        "upload firmware bundle container info": "",
        "upload firmware downgrade protection info": "Версії прошивки 04.00.00 і вище містять захист від пониження версії. Для отримання детальнішої інформації про зміни в прошивці, будь ласка, ознайомтеся з нашою документацією на <1>Teltonika GPS Wiki</1>. Натискаючи кнопку «Далі», ви погоджуєтеся та розумієте вищезазначену інформацію.",
        "upload firmware unsupported info": "Оновлення до цієї версії недоступне, будь ласка, зверніться до служби підтримки Teltonika або до вашого менеджера з продажу Teltonika.",
        "use at least one filter": "Будь ласка, використовуйте принаймні один фільтр",
        "user": "Користувач",
        "valid until": "Дійсна до",
        "valid until date disable description": "Це поле можна змінити лише тоді, коли період часу встановлено на «Налаштований»",
        "vehicle model": "Модель"
    },
    "Dropzone": {
        "add file": "Додати файл",
        "add files": "Додати файли",
        "drop file to upload": "Перетягніть файл для завантаження",
        "drop files to upload": "Перетягніть файли для завантаження",
        "error uploading the file": "Сталася помилка під час завантаження файлу",
        "file invalid type": "Вибрано недійсний тип файлу.",
        "file successfully uploaded": "Файл успішно завантажено",
        "file syntax": "Синтаксис файлу такий:",
        "invalid format or size": "",
        "max file size": "",
        "maximum file limit reached": "Досягнуто максимальний ліміт файлів.",
        "only one file can be attached": "Можна додати тільки один файл.",
        "or drop file to upload": "Або перетягніть файл для завантаження",
        "or drop files to upload": "Або перетягніть файли для завантаження",
        "rows detected": "Рядки у файлі успішно виявлені",
        "select file": "Вибрати файл",
        "select files": "Вибрати файли",
        "select file type": "Спочатку виберіть тип файлу.",
        "supported formats": "Підтримувані формати",
        "too long file name": "Ім'я файлу занадто довге. Дозволено максимум {{maxLength}} символів.",
        "too many files description": "Решту файлів можна завантажити після завантаження вибраних файлів.",
        "too many files title": "Існує максимальний ліміт {{maxFiles}} файлів, які можна додати одночасно."
    },
    "Error": {
        "error": "Помилка",
        "message wait": "Будьте терплячі, поки ми виправимо помилку.",
        "title": "Сталася помилка!"
    },
    "Feature highlight": {
        "got it": "Зрозуміло",
        "new feature": "Нова функція!",
        "scenarios description": "Тепер ви можете встановити на своєму пристрої один із таких сценаріїв: перевищення швидкості, виявлення аварії або виявлення буксирування."
    },
    "Filter": {
        "access group": "",
        "activity_status": "Статус",
        "all permissions": "Всі дозволи",
        "batch_id": "Ідентифікатор партії",
        "company_id": "Компанія",
        "company selector": "",
        "configuration change origin": "",
        "configuration_file_id": "",
        "configuration type": "",
        "created_by": "Створено",
        "current_configuration": "Конфігурація",
        "current_firmware": "Прошивка",
        "device_imei": "IMEI пристрою",
        "file type": "Тип файлу",
        "filtered by": "Відфільтровано за",
        "filters used": "Використані фільтри",
        "firmware_file_id": "",
        "ft_bluetooth_auth_list_file_id": "",
        "ft_configuration_file_id": "",
        "ft_firmware_file_id": "",
        "ft_one_wire_auth_list_file_id": "",
        "group_id": "Група",
        "id": "ID",
        "Invalid company": "Недійсна компанія",
        "model": "Модель",
        "model_platform": "Платформа",
        "Multiple companies": "Кілька компаній",
        "parent company": "Материнська компанія",
        "permission": "Дозвіл",
        "permission status": "Статус",
        "role": "Роль",
        "spec_id": "Spec ID",
        "status_id": "Статус",
        "supported_task_type": "Тип завдання",
        "table filters": "Фільтри таблиці",
        "task type": "Тип завдання",
        "task_queue": "Черга",
        "type": "Тип",
        "user status": "Статус"
    },
    "Flash": {
        "account was deleted": "",
        "ADAS firmware file size can't be zero": "Розмір файлу прошивки ADAS не може дорівнювати нулю.",
        "ADAS firmware is invalid.": "Прошивка ADAS недійсна.",
        "All notifications were deleted.": "Усі повідомлення були видалені.",
        "All notifications were marked as read.": "Усі повідомлення були позначені як прочитані.",
        "At least one user role must be provided.": "Повинна бути передбачена принаймні одна роль користувача.",
        "Attributes length is invalid": "Довжина атрибутів недійсна.",
        "Banner was updated.": "",
        "Batch was discarded": "Партія була відхилена.",
        "Bulk attribute update job was created. Devices' attributes will be updated shortly.": "Створено завдання масового оновлення атрибутів. Атрибути пристроїв будуть оновлені найближчим часом.",
        "Bulk create job was created. Devices will be created shortly.": "Створено завдання масового створення. Пристрої будуть створені найближчим часом.",
        "Bulk create job was created. Tasks will be created shortly.": "Створено завдання масового створення. Завдання будуть створені найближчим часом.",
        "Bulk delete job was created. Companies will be removed shortly.": "Створено завдання масового видалення. Компанії будуть видалені найближчим часом.",
        "Bulk delete job was created. Devices will be removed shortly.": "Створено завдання масового видалення. Пристрої будуть видалені найближчим часом.",
        "Bulk delete job was created. Files will be removed shortly.": "Створено завдання масового видалення. Файли будуть видалені найближчим часом.",
        "Bulk delete job was created. Groups will be removed shortly.": "Створено завдання масового видалення. Групи будуть видалені найближчим часом.",
        "Bulk delete job was created. Product codes will be removed shortly.": "Створено завдання масового видалення. Коди продуктів будуть видалені найближчим часом.",
        "Bulk delete job was created. Users will be removed shortly.": "Створено завдання масового видалення. Користувачі будуть видалені найближчим часом.",
        "Bulk task create job was created. Tasks will be created shortly.": "Було створено завдання масового виконання, і завдання з'являться найближчим часом. Завдання можна знайти на сторінці «Групи завдань» у розділі «Деталі групи завдань».",
        "Bulk update job was created. Devices will be updated shortly.": "Створено завдання масового оновлення. Пристрої будуть оновлені найближчим часом.",
        "Bulk update job was created. Tasks will be updated shortly.": "Створено завдання масового оновлення. Завдання будуть оновлені найближчим часом.",
        "Can adapter was added.": "Можливо додати адаптер.",
        "Can adapter was deleted.": "Адаптер Can було видалено.",
        "Can adapter was updated.": "Адаптер Can було оновлено.",
        "Can chip firmware file size can't be zero": "Розмір файлу прошивки чіпа не може бути нульовим.",
        "Can chip firmware is invalid.": "Можливо, прошивка чіпа недійсна.",
        "Cannot delete company. Company is not empty.": "Неможливо видалити компанію. Компанія не є порожньою.",
        "Cannot delete file. It is used by pending or running tasks.": "Неможливо видалити файл. Він використовується для завдань, що очікують на виконання або виконуються.",
        "Cannot delete file. It is used by running tasks.": "Неможливо видалити файл. Він використовується для виконання завдань.",
        "Cannot delete file. There are tasks waiting for approval.": "",
        "Cannot delete product code assigned to devices.": "Неможливо видалити код продукту, присвоєний пристроям.",
        "check your email for details": "",
        "Companies count limit exceeded.": "Перевищено ліміт кількості компаній.",
        "Companies in the request must belong to the selected root.": "Компанії в запиті повинні належати до вибраного кореня.",
        "Company merge job was created. It will be merged shortly.": "Створено завдання злиття компаній. Злиття відбудеться найближчим часом.",
        "Company name already exist.": "Назва компанії вже існує.",
        "Company level change is not allowed.": "Зміна рівня компанії не допускається.",
        "Company level successfully changed": "Рівень компанії успішно змінено.",
        "company level successfully reverted": "Рівень компанії успішно повернувся до автоматично призначеного рівня.",
        "Company not allowed to be merged": "Компанія не може бути об'єднана.",
        "company resource limits changed": "Обмеження ресурсів компанії успішно змінено.",
        "Company was created.": "Компанія була створена.",
        "Company was deleted.": "Компанія була видалена.",
        "Company was updated.": "Компанія була оновлена.",
        "compatibilities added": "{{count}} нових сумісностей додано під час синхронізації.",
        "compatibilities synchronized": "Успішно синхронізовано відсутні сумісності.",
        "Configuration cannot have FOTA functionality disabled": "У конфігурації не можна вимкнути функцію FOTA.",
        "Configuration file cannot contain duplicate parameters": "Файл конфігурації не може містити дубльовані параметри.",
        "Configuration file size can't be zero": "Розмір конфігураційного файлу не може дорівнювати нулю.",
        "Configuration files count limit exceeded.": "Перевищено обмеження кількості конфігураційних файлів.",
        "Configuration version must be defined": "Необхідно визначити версію конфігурації.",
        "custom resource limits successfully reverted": "Обмеження ресурсів, встановлені користувачем, успішно повернуті до автоматично призначених обмежень.",
        "Custom roles feature is not enabled.": "Функція налаштування ролей доступна тільки для користувачів з преміум-рівнем компанії. Раніше створені налаштовані ролі можна видалити.",
        "desktop license added": "Ліцензія для desktop-комп'ютерів «{{name}}» успішно додана.",
        "Devices already are in target company": "Пристрої вже знаходяться в цільовій компанії.",
        "Device already exists.": "Пристрій вже існує.",
        "Device bulk attribute update file cannot be empty": "Файл масового оновлення атрибутів пристрою не може бути порожнім.",
        "Device bulk attribute update file should be .csv": "Файл для масового оновлення атрибутів пристроїв повинен мати формат .csv.",
        "Device export limit reached. You can not export more than 100000 devices": "Досягнуто ліміт експорту пристроїв. Ви не можете експортувати більше 100 000 пристроїв.",
        "Device import limit reached. You can not import more than 100 devices": "Досягнуто обмеження на імпорт пристроїв. Ви не можете імпортувати більше 100 пристроїв.",
        "Device model and task type compatibility was updated.": "Оновлено сумісність моделей пристроїв та типів завдань.",
        "Device model was created.": "Створено модель пристрою.",
        "Device model was deleted.": "Модель пристрою була видалена.",
        "Device model was updated.": "Модель пристрою була оновлена.",
        "Device not found": "Пристрій не знайдено.",
        "Device Transfer job was created. Devices will be transfered shortly.": "Завдання на перенесення пристроїв створено. Пристрої будуть перенесені найближчим часом.",
        "Device was added.": "Пристрій додано.",
        "Device was deleted.": "Пристрій було видалено.",
        "Device was updated.": "Пристрій було оновлено.",
        "Email or password is incorrect.": "Введений вами електронний адрес або пароль є неправильним.",
        "Failed to create Product code": "Не вдалося створити код продукту.",
        "Failed to delete Product code": "Не вдалося видалити код продукту.",
        "Failed to import devices.": "Не вдалося імпортувати пристрої.",
        "Failed to Read Product code": "Не вдалося прочитати код продукту.",
        "Failed to retry failed tasks": "Не вдалося повторити невдалі завдання.",
        "Failed to update Product code": "Не вдалося оновити код продукту.",
        "Failed to update task for retry": "Не вдалося повторити невдале завдання.",
        "Field is not valid": "Поле не є дійсним.",
        "File description is too long. Max 255 characters allowed.": "Опис файлу занадто довгий. Дозволено максимум 255 символів.",
        "File exceeds entries limit of 10000.": "Файл перевищує обмеження в 10 000 записів.",
        "File must not contain duplicated IMEIs": "Файл не повинен містити дубльовані IMEI.",
        "File must not contain IMEIs that already exist in database.": "Файл не повинен містити IMEI, які вже існують у базі даних.",
        "File must not contain invalid IMEIs": "Файл не повинен містити недійсні IMEI-коди.",
        "File name is too long. Max 255 characters allowed.": "Ім'я файлу занадто довге. Допустима максимальна довжина - 255 символів.",
        "File name should not contain illegal characters or symbols": "Ім'я файлу не може містити спеціальних символів.",
        "File not found": "Файл не знайдено.",
        "File was deleted.": "Файл було видалено.",
        "File was successfully uploaded.": "Файл було успішно завантажено.",
        "File was updated.": "Файл було оновлено.",
        "File was uploaded. Devices will be imported shortly.": "Файл завантажено. Пристрої будуть імпортовані найближчим часом.",
        "File will be created shortly. Check files in a second.": "Файл буде створено незабаром. Перевірте файли через секунду.",
        "Firmware already exists in global files.": "",
        "Firmware bundle already exists in global files.": "",
        "Firmware file size can't be zero": "Розмір файлу прошивки не може бути нульовим.",
        "First device in file not found.": "Перший пристрій у файлі не знайдено.",
        "Forbidden": "Заборонено.",
        "Group name already exist.": "Назва групи вже існує.",
        "Group was added.": "«{{group}}» успішно створено.",
        "Group was created.": "Група створена.",
        "Group was deleted.": "Група була видалена.",
        "Group was updated.": "Група була оновлена.",
        "Invalid device bulk update attribute": "Недійсний атрибут масового оновлення пристрою.",
        "Invalid email address.": "Неправильна адреса електронної пошти.",
        "Invalid file contents": "Недійсний вміст файлу.",
        "Invalid file name": "Неправильне ім'я файлу.",
        "Invalid invitation token.": "Недійсний токен запрошення.",
        "Invalid token": "Недійсний токен.",
        "Invalid token length": "Неправильна довжина токена.",
        "Internal Server Error": "Внутрішня помилка сервера.",
        "Internal users must sign in using Microsoft Entra ID.": "",
        "License was deleted.": "Ліцензія була видалена.",
        "License was updated.": "Ліцензія була оновлена.",
        "Maximum companies hierarchy depth exceeded": "Максимальна глибина ієрархії компаній перевищена",
        "Maximum device group size exceeded.": "Перевищено максимальний розмір групи пристроїв.",
        "Method Not Allowed": "Метод не дозволений.",
        "Network Error": "Помилка мережі.",
        "No changes made": "Зміни не вносилися.",
        "No resources found.": "Ресурси не знайдені.",
        "not allowed to affect batch": {
            "description": "Переконайтеся, що ви контролюєте компанію користувача, який створив цю групу завдань.",
            "title": {
                "approve": "Ви не маєте дозволу на затвердження цього пакету.",
                "discard": "Ви не маєте дозволу на видалення цього пакета."
            }
        },
        "Not Found": "Не знайдено.",
        "Notification was deleted.": "Повідомлення було видалено.",
        "notify when done title": "Це може зайняти деякий час. Натисніть кнопку нижче, щоб закрити цей екран, і ви отримаєте повідомлення, коли процес буде завершено.",
        "Obd record was created.": "Створено запис OBD.",
        "Obd record was updated.": "Запис OBD було оновлено.",
        "offline license added": "Офлайн-ліцензія «{{name}}» була успішно додана.",
        "Offline license was deleted.": "Офлайн-ліцензія була видалена.",
        "Only id_list source is supported.": "Підтримується тільки джерело id_list.",
        "Only users with Teltonika email can be invited into internal companies.": "До внутрішніх компаній можуть бути запрошені тільки користувачі з електронною поштою Teltonika.",
        "Only users with Teltonika email can be moved into internal companies.": "Тільки користувачі з електронною поштою Teltonika можуть бути переведені у внутрішні компанії.",
        "Parent company cannot be a descendant of the updated company.": "Материнська компанія не може бути нащадком оновленої компанії.",
        "Password reset link was sent to Your email.": "Посилання для скидання пароля було надіслано на вашу електронну адресу.",
        "Password reset token is invalid, expired or related user no longer exists.": "Токен для скидання пароля недійсний, термін його дії закінчився або користувач більше не існує.",
        "Password was changed.": "Пароль було змінено.",
        "product code added": "Код продукту «{{code}}» успішно додано.",
        "Product code is too long. Max 200 characters allowed.": "Код продукту занадто довгий. Допустима максимальна довжина - 200 символів.",
        "ProductCode already exists.": "Код продукту вже існує.",
        "ProductCode not found": "Код продукту не знайдено.",
        "Product code was deleted.": "Код продукту було видалено.",
        "Product code was updated.": "Код продукту було оновлено.",
        "Retry failed tasks job was created": "Створено завдання повторної спроби виконання невдалих завдань.",
        "Role cannot be set for an internal user.": "Роль не може бути встановлена для внутрішнього користувача.",
        "Role was created.": "Роль створено.",
        "Role was deleted.": "Роль була видалена.",
        "Role was updated.": "Роль була оновлена.",
        "selected company changed": "Вибрана компанія була змінена.",
        "Selected firmware bundle is not supported by the device.": "Вибраний пакет прошивки не підтримується пристроєм.",
        "Server Error": "Помилка сервера.",
        "signalr connection failed": "",
        "signalr join groups failed": "",
        "SMS was sent.": "SMS було надіслано.",
        "Something went wrong while saving a new password.": "Під час збереження нового пароля сталася помилка.",
        "Successfully logged out.": "Ви успішно вийшли з системи.",
        "System Admin user level is required in order to perform this action.": "Для виконання цієї дії необхідний рівень користувача системного адміністратора.",
        "Target company cannot be a descendant of source company.": "Цільова компанія не може бути нащадком вихідної компанії.",
        "Task create limit exceeded.": "Неможливо створити групу завдань для більш ніж 100 000 пристроїв.",
        "Task type is not retriable": "Тип завдання не підлягає повторному виконанню",
        "Task was added.": "Завдання додано.",
        "task was created": "Завдання було створено для {{imei}} («{{taskType}}»). Завдання можна знайти на сторінці «Пристрої» в розділі «Завдання» детальної інформації про пристрій.",
        "Task was updated.": "Завдання було оновлено.",
        "Tasks were approved": "Завдання були затверджені.",
        "The given data was invalid.": "Надані дані були недійсними.",
        "time zone changed": "Часовий пояс було змінено.",
        "Token cannot be null or empty": "Токен не може бути нульовим або порожнім.",
        "token created": "API-токен успішно створено.",
        "Token has expired": "Термін дії токена закінчився.",
        "Token's and token's owner companies do not match": "Токени та компанії-власники токенів не збігаються.",
        "Token was deleted.": "Токен було видалено.",
        "Too many resources in the request": "Занадто багато ресурсів у запиті",
        "Too Many Requests": "Занадто багато запитів.",
        "Transfer token created": "Створено токен передачі.",
        "tutorial completed": "",
        "Two factor authentication is already activated for the user.": "Двофакторна аутентифікація вже активована для користувача.",
        "Two factor authentication successfully disabled.": "Двофакторна аутентифікація успішно вимкнена.",
        "Unable to send SMS. This device does not have a GSM number assigned.": "Неможливо надіслати SMS. Цьому пристрою не присвоєно номер GSM.",
        "Unable to validate Your request.": "Неможливо перевірити Ваш запит.",
        "Unauthenticated.": "Неавтентифікована.",
        "Unauthorized": "Несанкціонований доступ.",
        "User access level is not valid": "Рівень доступу користувача недійсний",
        "User invitation was revoked": "Запрошення успішно скасовано.",
        "User invitation was re-sent": "Запрошення користувача було надіслано повторно.",
        "User is already in the system.": "Користувач вже знаходиться в системі.",
        "User was created.": "Користувач створений.",
        "User was deleted.": "Користувач був видалений.",
        "User was invited.": "Запрошення користувача успішно надіслано.",
        "User was updated": "Користувач був оновлений.",
        "Users count limit exceeded.": "Перевищено обмеження кількості користувачів.",
        "Your password has been changed.": "Ваш пароль було змінено."
    },
    "General": {
        "0": "Користувач",
        "5": "Підтримка",
        "10": "Адміністратор",
        "15": "Адміністратор",
        "19": "",
        "20": "Користувач системи",
        "99": "Суперкористувач",
        "--- START-OF-PERMISSIONS ---": "",
        "Company.Create": "Створення компанії",
        "Company.Delete": "Видалити компанію",
        "Company.Merge": "Об'єднання компаній",
        "Company.Update": "Оновлення компанії",
        "Device.Export": "Експорт пристроїв",
        "Device.Read": "Зчитування даних з пристроїв",
        "Device.SecretsRead": "",
        "Device.Transfer": "Передача пристроїв",
        "Device.Unlock": "Розблокування пристрою",
        "Device.Update": "Оновлення пристроїв",
        "DeviceGroup.Create": "Створення групи пристроїв",
        "DeviceGroup.Delete": "Видалення групи пристроїв",
        "DeviceGroup.Read": "Читання групи пристроїв",
        "DeviceGroup.Update": "Оновлення групи пристроїв",
        "File.Create": "Створення файлів",
        "File.Delete": "Видалення файлів",
        "File.Download": "Завантаження файлів",
        "File.Read": "Читання файлів",
        "File.TctWebAccess": "TCT web",
        "File.Update": "Оновлення файлів",
        "Role.Create": "Створення ролі",
        "Role.Delete": "Видалення ролі",
        "Role.Read": "Роль читання",
        "Role.Update": "Оновлення ролі",
        "Task.Create": "Створення завдань",
        "Task.Read": "Завдання прочитано",
        "Task.Retry": "Повторна спроба виконання завдання",
        "Task.Update": "Оновлення завдань",
        "TaskGroup.Read": "Читання групи завдань",
        "TctIntegration.Access": "Інтеграція TCT",
        "Token.Create": "Створення токенів",
        "Token.Delete": "Видалення токенів",
        "Token.Read": "Зчитування токенів",
        "User.Create": "",
        "User.Delete": "Видалення користувача",
        "User.Read": "Читання користувачем",
        "User.Update": "Оновлення користувача",
        "--- END-OF-PERMISSIONS ---": "",
        "1_wire_authorization": "",
        "1-wire authorization list": "Список авторизації 1-Wire",
        "1_wire_authorization_list": "Список авторизації 1-Wire",
        "Active": "Активний",
        "adas_firmware": "Прошивка ADAS",
        "apx_firmware": "Прошивка APX",
        "assign can package": "Призначити пакет CAN",
        "assigned package": "Призначений пакет",
        "automatic": "Автоматична",
        "banner management": "",
        "batches": "Групи завдань",
        "black_box": "Чорний ящик",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Прошивка BLE",
        "blue_nrg": "Прошивка BlueNRG",
        "bluetooth_authorization": "",
        "BluetoothAuthorizationList": "",
        "bluetooth authorization list": "Список авторизації Bluetooth",
        "bluetooth_authorization_list": "Список авторизації Bluetooth",
        "bluetooth password": "",
        "boolean filtered value name": {
            "task_support": {
                "false": "Несумісна",
                "true": "Сумісна"
            },
            "web_editor_support": {
                "false": "TCT web не підтримується",
                "true": "Підтримка TCT web"
            }
        },
        "can": "CAN",
        "can adapter name": "Назва адаптера CAN",
        "can bootstring": "Bootstring",
        "can configuration": "Конфігурація OEM",
        "can_debug_log": "Журнал налагодження CAN",
        "can oem file package": "Пакет файлів OEM",
        "can oem file vehicle": "OEM-файл транспортного засобу",
        "can package": "OEM-пакет",
        "can program number": "Номер програми CAN",
        "can revision": "Перегляд CAN",
        "can software date": "Дані програмного забезпечення CAN",
        "can type": "Тип CAN",
        "Cancelled": "Скасовано",
        "cancel task": "Скасувати завдання",
        "can_chip_firmware": "Прошивка мікросхеми FM CAN",
        "carrier_advance_firmware": "Прошивка Carrier Advance",
        "carrier_advance_settings": "Carrier Advance налаштування",
        "carrier_apx_firmware": "Прошивка Carrier APX",
        "carrier_apx_settings": "Налаштування Carrier APX",
        "carrier_extractions": "Carrier extractions",
        "carrier_logger_files": "Файли реєстратора температури Carrier",
        "certificate": "Сертифікат",
        "click for more details": "Натисніть, щоб дізнатися більше",
        "client ip": "IP-адреса клієнта",
        "clone model": "Клонування моделі пристрою",
        "collapse menu": "Згорнути меню",
        "companies": "Компанії",
        "company": "Компанія",
        "company level": "Рівень компанії",
        "company type": "Тип компанії",
        "company name": "Назва компанії",
        "Completed": "Завершено",
        "Completed with errors": "Завершено з помилками",
        "configuration": "Конфігурація",
        "configuration_36": "Конфігурація (FM36)",
        "configuration_64": "Конфігурація (FMB64)",
        "crash_dump": "Журнал аварійних збіїв",
        "created at": "Створено в",
        "created by": "Створено",
        "custom": "Налаштована",
        "custom resource limits": "Індивідуальні обмеження ресурсів",
        "dashboard": "Панель управління",
        "delete desktop license": "Видалити ліцензію для desktop комп'ютерів",
        "delete offline license": "Видалити офлайн-ліцензію",
        "desktopLicenses": "Ліцензії для настільних комп'ютерів",
        "device_export_file_csv": "Файл експорту пристроїв (.csv)",
        "device_export_file_xlsx": "Файл експорту пристроїв (.xlsx)",
        "deviceModels": "Моделі",
        "deviceModelTaskCompatibilities": "Сумісність",
        "device_transfer_report": "Звіт про передачу пристроїв",
        "device group": "Група",
        "DeviceImportFile": "Файл імпорту пристроїв",
        "devices": "Пристрої",
        "download file": "Завантажити файл",
        "download offline license": "Завантажити офлайн-ліцензію",
        "dsm_firmware": "Прошивка DSM",
        "dtb": "DTB",
        "edit compatibility": "Редагування сумісності пристроїв",
        "edit model": "Редагувати модель пристрою",
        "edit company": "Редагувати компанію",
        "edit desktop license": "Редагувати ліцензію для desktop-комп'ютерів",
        "edit device": "Редагувати пристрій",
        "edit file": "Редагувати файл",
        "edit group": "Редагувати групу",
        "edit in tct web": "Редагувати в TCT web",
        "edit in tct web disabled": "Редагування в TCT web доступне тільки для компаній рівня Premium.",
        "edit product code": "Редагувати код продукту",
        "edit role": "Редагувати роль",
        "edit smart group": "Редагувати розумну групу",
        "edit user": "Редагувати користувача",
        "Empty": "Порожня",
        "enter here": "Увійдіть тут",
        "exception_info": "Інформація про винятки",
        "Executing": "Виконання",
        "expand menu": "Розгорнути меню",
        "Expired": "Термін дії закінчився",
        "Factory": "",
        "Failed": "Не вдалося",
        "file": "Файл",
        "file data": "Дані файлів",
        "files": "Файли",
        "file deleted": "Файл було видалено",
        "firmware": "Прошивка",
        "firmware_36": "Прошивка (FM36)",
        "firmware_64": "Прошивка (FMB64)",
        "Fmx": "FMx",
        "Fota": "",
        "Ft": "FT",
        "fw_bundle": "Пакет прошивок",
        "fw_bundle_ble": "Пакет - прошивка BLE",
        "fw_bundle_ble_dtb": "Пакет - BLE DTB",
        "fw_bundle_can": "Пакет - прошивка CAN",
        "fw_bundle_can_dtb": "Пакет - CAN DTB",
        "fw_bundle_dtb": "Пакет - Основний DTB",
        "fw_bundle_mainfw": "Пакет - Основне вбудоване програмне забезпечення",
        "generic": "",
        "global_configuration": "Глобальна конфігурація",
        "global_firmware": "Глобальне вбудоване програмне забезпечення",
        "gnssm_download_assistant": "GNSS-M Download Assistant",
        "gnssm_firmware": "Прошивка GNSS-M",
        "group": "Група",
        "groups": "Групи пристроїв",
        "hardware key": "Апаратний ключ",
        "id": "ID",
        "id_collection_file": "Файл збору ідентифікаційних даних",
        "imei restriction": "Обмеження IMEI",
        "Inactive": "Неактивних",
        "Invalid": "Недійсний",
        "invalid model": "Недійсна модель",
        "invalid model_name": "Недійсна модель",
        "InvitationExpired": "Запрошення, термін дії якого закінчився",
        "InvitationPending": "Очікування запрошення",
        "Legacy": "Legacy",
        "legacy model": "Застаріла модель",
        "legacy model_platform": "Застаріла платформа",
        "legacy platform": "Застаріла платформа",
        "license has expired": "Термін дії ліцензії закінчився",
        "loading": "Завантаження",
        "log": "Журнал",
        "MainConfiguration": "",
        "main configuration": "",
        "manual": "Ручний",
        "ManualGeofenceList": "",
        "manual geofence list": "Список сценаріїв ручного геофенсінгу",
        "manual_geofence_list": "Список сценаріїв ручного геофенсінгу",
        "manual_geofence_scenarios": "",
        "meig_modem_firmware": "Прошивка модему MeiG",
        "menu": "Меню",
        "modem version": "Версія для модему",
        "netprisma_modem_firmware": "Прошивка модему NETPRISMA",
        "nmea_log": "Журнал NMEA",
        "no": "Ні",
        "no results": "Початкових результатів не знайдено",
        "no results description": "Як тільки {{name}} буде завантажено до FOTA WEB, ви зможете переглянути дані тут",
        "not assigned": "Не призначено",
        "not assigned configuration_file_id": "Конфігурація не призначена",
        "not assigned current_configuration": "Конфігурація не призначена",
        "not assigned current_firmware": "Прошивка не призначена",
        "not assigned firmware_file_id": "Прошивка не призначена",
        "not assigned group_id": "Група не призначена",
        "not assigned model": "Модель не призначена",
        "not assigned spec_id": "Spec ID не призначено",
        "not assigned task_type": "Тип завдання не призначений",
        "obd_chip_firmware": "Прошивка FM OBD Chip",
        "obd chip firmware version": "Версія прошивки чіпа OBD",
        "Offline": "Офлайн",
        "offline licenses": "Офлайн-ліцензії",
        "Online": "Онлайн",
        "OneWireAuthorizationList": "",
        "open in tct": "",
        "or": "або",
        "other": "Інше",
        "Pending": "В очікуванні",
        "Pending approval": "Очікує на затвердження",
        "permission disabled": "Вимкнено",
        "permission enabled": "Увімкнено",
        "productCodes": "Коди продуктів",
        "psub": "Файл передплати",
        "quectel_fw": "Прошивка модему Quectel (quectel_fw)",
        "quectel_modem_firmware": "Прошивка модему Quectel",
        "resend invite": "Повторно надіслати запрошення",
        "restricted": "Обмежений доступ",
        "retry": "Повторити спробу",
        "roles": "Ролі та дозволи",
        "Running": "Працює",
        "RxAutoscan": "Отримання файлу CAN за допомогою автосканування",
        "RxBlackBox": "Отримання чорного ящика",
        "RxBluetoothAuthorizationList": "Отримання списку авторизованих Bluetooth-пристроїв",
        "RxCanDebugLog": "Отримання журналу налагодження CAN",
        "RxCarrierExtractions": "Завантажити Carrier extractions",
        "RxCarrierLoggerFiles": "Завантажити файли реєстратора температури Carrier",
        "RxConfiguration": "Отримання конфігурації",
        "RxCrashDump": "Отримання журналу аварійних збіїв",
        "RxExceptionInfo": "Отримання інформації про винятки",
        "RxLog": "Отримання внутрішнього журналу",
        "RxManualGeofenceList": "Отримання списку сценаріїв ручного геофенсінгу",
        "RxNmeaLog": "Отримання журналу NMEA",
        "RxOneWireAuthorizationList": "Отримання списку авторизації 1-Wire",
        "RxWdLog": "Отримання журналу сторожового пристрою (WD)",
        "select company": "Вибрати компанію",
        "SetBindSim": "Прив'язування пристрою до поточної SIM-карти (карт)",
        "SetBluetoothPassword": "",
        "SetDisableFeature": "Вимкнути функцію",
        "SetEnableFeature": "Увімкнути функцію",
        "SetForceLockSim": "Примусове блокування SIM-карти",
        "SetUnbindSim": "Від'єднати пристрій від SIM-картки (карт)",
        "simcom_modem_firmware": "",
        "SmsGprs": "",
        "status": "Статус",
        "task details": "Деталі завдання",
        "task groups": "Групи завдань",
        "tasks": "Групи завдань",
        "tasksCompatibility": "Сумісність завдань",
        "task type": "Тип завдання",
        "Tct": "",
        "time zone": "Часовий пояс",
        "total": "Загалом",
        "tutorials": "Допомога",
        "TxAdasFirmware": "Завантаження прошивки ADAS",
        "TxAgpsMt3333": "Передача файлу AGPSM",
        "TxAgpsQuectelL89": "Передача файлу AGPSQ",
        "TxAutoscanCanConfiguration": "Завантажити файл автосканування OEM",
        "TxBleFirmware": "Завантаження прошивки BLE",
        "TxBlueNrgFirmware": "Завантажити прошивку BlueNrg",
        "TxBluetoothAuthorizationList": "Завантаження списку авторизації Bluetooth",
        "TxBundleBle": "Завантаження прошивки BLE",
        "TxBundleBleDtb": "Завантаження BLE DTB",
        "TxBundleCan": "Завантаження прошивки CAN",
        "TxBundleCanDtb": "Завантаження CAN DTB",
        "TxBundleDtb": "Завантажити головний DTB",
        "TxBundleFirmware": "Завантаження основного прошивання",
        "TxCanAdapterModeChange": "Зміна режиму зовнішнього CAN-адаптера",
        "TxCanAdapterModeChangeInternal": "Зміна режиму внутрішнього CAN-адаптера",
        "TxCanAdapterUpdate": "Завантаження прошивки адаптера CAN",
        "TxCanAdapterUpdateInternal": "Оновлення внутрішнього адаптера CAN",
        "TxCanChipFirmware": "Завантаження прошивки чіпа FMXY50 CAN",
        "TxCanConfiguration": "Завантажити файл OEM",
        "TxCarrierAdvanceFirmware": "Оновлення прошивки Carrier Advance",
        "TxCarrierAdvanceSettings": "Оновити налаштування Carrier Advance",
        "TxCarrierApxFirmware": "Оновлення прошивки Carrier APX",
        "TxCarrierApxSettings": "Оновлення налаштувань Carrier APX",
        "TxConfiguration": "Завантаження конфігурації",
        "TxDsmFirmware": "Завантаження прошивки DSM",
        "TxDtb": "Завантажити DTB",
        "TxFirmware": "Завантаження прошивки",
        "TxFirmwareBundle": "Завантаження контейнера з пакетом прошивок",
        "TxFirmwareBundleParts": "Завантаження пакета прошивки",
        "TxFotaCertificate": "Оновлення сертифіката FOTA",
        "TxGenericFile": "",
        "TxGNSSMDownloadAssistant": "Завантажити GNSS-M Download Assistant",
        "TxGNSSMFirmware": "Завантаження прошивки GNSS-M",
        "TxManualGeofenceList": "Завантаження списку сценаріїв ручного геофенсінгу",
        "TxMeigModemDeltaFirmware": "Завантажити прошивку для модему MeiG Delta",
        "TxNetprismaModemDeltaFirmware": "Завантажити прошивку для модему NETPRISMA Delta",
        "TxObdChipFirmware": "Оновлення чіпа OBD",
        "TxObdConfig": "Передача файлу конфігурації OBD",
        "TxOneWireAuthorizationList": "Завантажити список авторизації 1-Wire",
        "TxPSub": "Передача файлу передплати",
        "TxQuectelModemDeltaFirmware": "Завантажити прошивку модему Quectel Delta",
        "TxSimcomModemDeltaFirmware": "",
        "TxUserCertificate": "Завантажити сертифікат TLS користувача",
        "users": "Користувачі",
        "Unknown": "Невідомо",
        "unknown": "Невідомо",
        "unknown model_platform": "Невідома платформа",
        "unknown origin": "",
        "unknown platform": "Невідома платформа",
        "unrestricted": "Без обмежень",
        "Verifying": "Перевірка",
        "vin": "VIN",
        "vip status": "VIP-статус",
        "wd_log": "Журнал WD",
        "yes": "Так"
    },
    "Maintenance": {
        "title": "Зачекайте! Ми проводимо технічне обслуговування."
    },
    "Notifications": {
        "description": {
            "{{BackgroundActionType}} failed due to server error": "{{BackgroundActionType}} не вдалося виконати через помилку сервера.",
            "Cancel tasks action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу скасувати всі вибрані завдання. Деякі завдання пов'язані з ресурсами різних компаній.",
            "Cancel tasks action failed. No resources found.": "Жодне завдання не відповідає вашому вибору. Перегляньте свій вибір завдань і спробуйте ще раз.",
            "Company \"{{SourceCompanyName}}\" ({{SourceCompanyId}}) merged into \"{{TargetCompanyName}}\" (<TargetCompanyId>).": "Компанія «{{SourceCompanyName}}» ({{SourceCompanyId}}) об'єдналася з «{{TargetCompanyName}}» ({{TargetCompanyId}}).",
            "Company merge failed. Companies '{{SourceCompanyId}}' and '{{TargetCompanyId}}' cannot be merged due to incompatible settings or permissions.": "Злиття компаній не вдалося. Компанії «{{SourceCompanyId}}» та «{{TargetCompanyId}}» не можуть бути об'єднані через несумісність налаштувань або дозволів.",
            "Create device group tasks action failed. No resources found.": "Не вдалося створити завдання для Smart Group. Спробуйте перепризначити файл.",
            "{{CreatedTaskCount}} task(s) created for device group ID:{{GroupId}} devices.": "{{CreatedTaskCount}} завдань створено для групи пристроїв з ідентифікатором:{{GroupId}} пристроїв.",
            "Create tasks action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на створення завдань для всіх вибраних пристроїв. Деякі пристрої належать різним компаніям.",
            "Create tasks action failed. No resources found.": "Жодне з пристроїв не відповідає вашому вибору. Перегляньте свій вибір пристроїв і спробуйте ще раз.",
            "Create tasks action failed. No resources processed.": "Не вдалося обробити вибрані пристрої. Спробуйте створити групу завдань ще раз.",
            "Delete companies action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на видалення всіх вибраних компаній. Деякі компанії не перебувають під вашим безпосереднім управлінням.",
            "Delete companies action failed. No resources found.": "Жодна компанія не відповідає вашому вибору. Перегляньте вибір компаній і спробуйте ще раз.",
            "Delete files action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на видалення всіх вибраних файлів. Деякі файли пов'язані з ресурсами різних компаній.",
            "Delete files action failed. No resources found.": "Жоден файл не відповідає вашому вибору. Перегляньте свій вибір файлів і спробуйте ще раз.",
            "Delete groups action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на видалення всіх вибраних груп пристроїв. Деякі групи пристроїв містять ресурси різних компаній.",
            "Delete groups action failed. No resources found.": "Жодна група пристроїв не відповідає вашому вибору. Перегляньте вибір групи пристроїв і спробуйте ще раз.",
            "Delete product codes action failed. No resources found.": "Жоден код продукту не відповідає вашому вибору. Перегляньте свій вибір коду продукту та спробуйте ще раз.",
            "Delete users action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на видалення всіх вибраних користувачів. Деякі користувачі належать до різних компаній.",
            "Delete users action failed. No resources found.": "Жоден користувач не відповідає вашому вибору. Перегляньте свій вибір користувачів і спробуйте ще раз.",
            "Device group ID:{{GroupId}} move failed. Target company ID:{{TargetCompanyId}} cannot be found.": "",
            "Device group ID:{{GroupId}} successfully moved to company ID:{{TargetCompanyId}}.": "",
            "{{DevicesCount}} device(s) exported to \"{{Filename}}\".": "{{DevicesCount}} пристроїв експортовано до «{{Filename}}».",
            "{{DevicesCount}} device(s) imported.": "Імпортовано {{DevicesCount}} пристроїв.",
            "{{DevicesProcessedCount}} device(s) processed, {{TasksCreatedCount}} task(s) created.": "Оброблено {{DevicesProcessedCount}} пристроїв, створено {{TasksCreatedCount}} завдань.",
            "Export devices action failed. No resources found.": "Жодне з пристроїв не відповідає вашому вибору. Перегляньте свій вибір пристроїв і спробуйте ще раз.",
            "{{FailedTaskCount}} task(s) returned to pending in task group {{BatchId}}.": "{{FailedTaskCount}} завдань повернулися до статусу «очікують виконання» у групі завдань {{BatchId}}.",
            "Invalid request scope. Resources must belong to single root.": "Недійсний обсяг запиту. Ресурси повинні належати до одного кореня.",
            "Move device group action failed. No resources found.": "",
            "{{ProcessedCount}} companies deleted.": "Видалено {{ProcessedCount}} компаній.",
            "{{ProcessedCount}} device group(s) deleted.": "Видалено {{ProcessedCount}} груп пристроїв.",
            "{{ProcessedCount}} device attribute(s) updated.": "{{ProcessedCount}} атрибутів пристрою оновлено.",
            "{{ProcessedCount}} device model(s) deleted.": "Видалено {{ProcessedCount}} моделей пристроїв.",
            "{{ProcessedCount}} device(s) updated.": "{{ProcessedCount}} пристроїв оновлено.",
            "{{ProcessedCount}} file(s) deleted.": "{{ProcessedCount}} файлів видалено.",
            "{{ProcessedCount}} product code(s) deleted.": "{{ProcessedCount}} кодів продуктів видалено.",
            "{{ProcessedCount}} task(s) canceled.": "{{ProcessedCount}} завдань скасовано.",
            "{{ProcessedCount}} task(s) updated.": "{{ProcessedCount}} завдання оновлено.",
            "{{ProcessedCount}} user(s) deleted.": "Видалено {{ProcessedCount}} користувачів.",
            "Retry tasks action failed. No resources found.": "Жодне завдання не відповідає вашому вибору. Перегляньте свій вибір завдань і спробуйте ще раз.",
            "Transfer devices action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на передачу всіх вибраних пристроїв. Деякі пристрої належать іншим компаніям.",
            "Transfer devices action failed. No resources found.": "Жодне з пристроїв не відповідає вашому вибору. Перегляньте свій вибір пристроїв і спробуйте ще раз.",
            "Transfer devices action failed. No resources processed.": "Не вдалося обробити вибрані пристрої. Спробуйте перенести пристрої ще раз.",
            "{{TransferredDevicesCount}} of {{TotalDevicesToTransfer}} device(s) transferred.": "{{TransferredDevicesCount}} з {{TotalDevicesToTransfer}} пристроїв перенесено.",
            "Update devices action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на оновлення всіх вибраних пристроїв. Деякі пристрої належать іншим компаніям.",
            "Update devices action failed. No resources found.": "Жодне з пристроїв не відповідає вашому вибору. Перегляньте свій вибір пристроїв і спробуйте ще раз.",
            "Update devices attributes action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на оновлення атрибутів для всіх вибраних пристроїв. Деякі пристрої належать різним компаніям.",
            "Update devices attributes action failed. No resources found.": "Жодне з пристроїв не відповідає вашому вибору. Перегляньте свій вибір пристроїв і спробуйте ще раз.",
            "Update tasks action failed. Invalid request scope. Resources must belong to single root.": "Ви не маєте дозволу на оновлення всіх вибраних завдань. Деякі завдання пов'язані з ресурсами різних компаній.",
            "Update tasks action failed. No resources found.": "Жодне завдання не відповідає вашому вибору. Перегляньте свій вибір завдань і спробуйте ще раз.",
            "User access is scheduled to expire at {{ExpiresAt}} UTC. To maintain uninterrupted service, please contact your company's administrators immediately to request an extension.": ""
        },
        "no notifications": "Без сповіщень",
        "notifications": "Повідомлення",
        "notifications will be listed": "Усі нові повідомлення будуть відображатися тут",
        "remove notification": "Видалити повідомлення",
        "see previous notifications": "Переглянути попередні повідомлення",
        "timestamps": {
            "days ago": "{{days}} дні тому",
            "hours ago": "{{hours}} години тому",
            "minutes ago": "{{minutes}} хв тому",
            "moments ago": "Кілька хвилин тому"
        },
        "title": {
            "BackgroundActionFailed": "Дія не вдалася",
            "CompaniesSuccessfullyDeleted": "Компанії, які успішно видалили",
            "CompanyBulkDeleteFailed": "Під час видалення компаній сталася помилка",
            "CompanyLevelChanged": "Змінено рівень компанії",
            "CompanyLevelDowngradeReminder": "Майбутнє пониження рівня компанії",
            "CompanyMergeFailed": "Під час об'єднання компаній сталася помилка",
            "CompanySuccessfullyMerged": "Компанії успішно об'єдналися",
            "DeviceAttributesSuccessfullyUpdated": "Атрибути пристрою успішно оновлено",
            "DeviceBulkAttributeUpdateFailed": "Під час оновлення атрибутів пристрою сталася помилка",
            "DeviceBulkUpdateFailed": "Під час оновлення пристроїв сталася помилка",
            "DeviceExportFailed": "Під час експорту пристроїв сталася помилка",
            "DeviceGroupMoveFailed": "",
            "DeviceGroupsSuccessfullyDeleted": "Групи пристроїв успішно видалені",
            "DeviceGroupSuccessfullyMoved": "",
            "DeviceGroupTasksCreateFailed": "Під час створення завдань Smart Group сталася помилка",
            "DeviceGroupTasksSuccessfullyCreated": "Завдання Smart Group успішно створено",
            "DeviceModelBulkDeleteFailed": "Під час видалення моделей пристроїв сталася помилка",
            "DeviceModelsSuccessfullyDeleted": "Моделі пристроїв успішно видалені",
            "DevicesSuccessfullyTransferred": "Пристрої успішно перенесені",
            "DevicesSuccessfullyUpdated": "Пристрої успішно оновлено",
            "DeviceTransferFailed": "Під час передачі пристроїв сталася помилка",
            "ExportFailed": "Експорт ресурсів не вдався",
            "ExportSucceeded": "Пристрої успішно експортовані",
            "FailedTasksRetryFailed": "Під час повторної спроби виконання завдань сталася помилка",
            "FailedTasksSuccessfullyRetried": "Завдання успішно повторені",
            "FileBulkDeleteFailed": "Під час видалення файлів сталася помилка",
            "FilesSuccessfullyDeleted": "Файли успішно видалені",
            "GroupBulkDeleteFailed": "Під час видалення груп пристроїв сталася помилка",
            "ImportFailed": "Імпорт ресурсів не вдався",
            "ImportSucceeded": "Пристрої успішно імпортовані",
            "ProductCodeBulkDeleteFailed": "Під час видалення кодів продуктів сталася помилка",
            "ProductCodesSuccessfullyDeleted": "Коди продуктів успішно видалені",
            "ResourceUpdateFailed": "Оновлення ресурсу не вдалося",
            "ResourceUpdateSucceeded": "Оновлення ресурсу успішно завершено",
            "RoleBulkDeleteFailed": "Під час видалення ролей сталася помилка",
            "RolesSuccessfullyDeleted": "Ролі успішно видалені",
            "TaskBulkCancelFailed": "Під час скасування завдань сталася помилка",
            "TaskBulkCreateFailed": "Під час створення групи завдань сталася помилка",
            "TaskBulkUpdateFailed": "Під час оновлення завдань сталася помилка",
            "TaskGroupSuccessfullyCreated": "Група завдань успішно створена",
            "TasksPropagationFailed": "Помилка під час поширення завдання",
            "TasksPropagationSucceeded": "Завдання поширення завдань виконано успішно",
            "TasksPropagationWarning": "Завдання поширення завдань завершилося з попередженнями",
            "TasksSuccessfullyCanceled": "Завдання успішно скасовано",
            "TasksSuccessfullyUpdated": "Завдання успішно оновлено",
            "UserBulkDeleteFailed": "Під час видалення користувачів сталася помилка",
            "UserExpireReminder": "",
            "UsersSuccessfullyDeleted": "Користувачі успішно видалені"
        }
    },
    "Permission actions": {
        "Access": "Інтеграція TCT",
        "Create": "Створити",
        "Delete": "Видалити",
        "Download": "Завантажити",
        "Export": "Експорт",
        "Merge": "Об'єднати",
        "Read": "Читати",
        "Retry": "Повторити спробу",
        "SecretsRead": "",
        "TctWebAccess": "TCT web",
        "Transfer": "Передача",
        "Unlock": "Розблокувати",
        "Update": "Оновити"
    },
    "Permission groups": {
        "company": "Компанії",
        "device": "Пристрої",
        "device group": "Групи пристроїв",
        "file": "Файли",
        "role": "Ролі",
        "task": "Завдання",
        "task group": "Групи завдань",
        "token": "Токени",
        "user": "Користувачі"
    },
    "Restrictions": {
        "feature_settings": {
            "api_token_support": {
                "input option": "Ця опція недоступна для користувачів з базовим рівнем компанії.",
                "token list": "Токени інтеграції API відключені для користувачів з базовим рівнем компанії."
            },
            "custom_role_support": {
                "create role": "Ця функція доступна тільки для користувачів з преміум-рівнем компанії.",
                "edit role": "Ця функція доступна тільки для користувачів з преміум-рівнем компанії. Раніше створені користувацькі ролі можна видалити.",
                "edit user": "Ця функція доступна тільки для користувачів з преміум-рівнем компанії. Раніше призначені користувацькі ролі можуть бути видалені."
            },
            "task_schedule_support": {
                "table head": "Ця функція доступна тільки для користувачів з рівнями компанії Standard і Premium. Раніше додані завдання з розкладом будуть виконуватися як і раніше."
            }
        },
        "general message": "Ця функція доступна тільки для користувачів з рівнями компанії Standard і Premium.",
        "resource_limit_settings": {
            "tasks_per_group": "Ви не можете створювати завдання для більш ніж {{limitCount}} пристроїв одночасно."
        }
    },
    "Search": {
        "code": "Код",
        "description": "Опис",
        "email": "Електронна пошта",
        "iccid": "",
        "id": "ID",
        "imei": "IMEI",
        "model": "Модель",
        "name": "Назва",
        "product code": "Код продукту",
        "role name": "Назва ролі",
        "serial": "Серійний номер.",
        "search by": "Пошук за",
        "search company name": "Пошук назви компанії"
    },
    "Security": {
        "2FA": {
            "disable": {
                "confirmation": {
                    "description": "Ви збираєтеся вимкнути двофакторну автентифікацію. Це може зробити ваш обліковий запис FOTA WEB незахищеним. Ви впевнені, що хочете продовжити?",
                    "title": "Ви впевнені?"
                },
                "send email code": {
                    "enter code": "З міркувань безпеки, будь ласка, введіть код для підтвердження електронної адреси."
                },
                "send otp code": {
                    "description": "6-значний код був надісланий на ваш додаток для автентифікації. З міркувань безпеки, будь ласка, введіть згенерований код у поле нижче.",
                    "no access": {
                        "authenticator": "Якщо ви більше не маєте доступу до програми-аутентифікатора, пов'язаної з цим обліковим записом, для вимкнення двофакторної аутентифікації потрібно змінити пароль.",
                        "email": "Якщо ви більше не маєте доступу до електронної пошти, пов'язаної з цим обліковим записом, необхідно змінити пароль, щоб вимкнути багатофакторну автентифікацію."
                    }
                },
                "title": "Вимкнути двофакторну автентифікацію"
            },
            "get email code": {
                "description": "Використовуйте цей код на наступному екрані, щоб підтвердити свій обліковий запис.",
                "description modal": "Використовуйте цей код для підтвердження свого облікового запису.",
                "title": "Натиснувши «Надіслати код», унікальний код буде надіслано на <1>{{email}}</1>."
            },
            "get secret code": {
                "description": "Для завершення цього процесу вам знадобиться мобільний додаток-аутентифікатор, наприклад один із таких:"
            },
            "select authentication type": {
                "authentication app description": "Отримайте унікальний код з додатка, такого як Microsoft Authenticator або Google Authenticator.",
                "description": "Щоб забезпечити безпеку вашого облікового запису та даних клієнтів, скористайтеся одним із наведених нижче варіантів для налаштування двофакторної автентифікації.",
                "description modal": "Виберіть бажаний метод аутентифікації.",
                "email": "Електронна пошта",
                "email description": "Ми надішлемо одноразовий код на вашу електронну адресу, коли ви спробуєте увійти в систему.",
                "recommended": "Рекомендовано",
                "title": "Двофакторна аутентифікація (2FA) є обов'язковою для всіх користувачів FOTA WEB.",
                "title modal": "Виберіть метод аутентифікації"
            },
            "send email code": {
                "description": "Введіть код у поле нижче та натисніть «Перевірити», щоб продовжити.",
                "enter code": "Введіть код для підтвердження електронної адреси.",
                "title": "Унікальний код був надісланий на <1>{{email}}</1>.",
                "verification code": "Код підтвердження"
            },
            "send otp code": {
                "click to scan code": "Натисніть тут, щоб відсканувати QR-код",
                "click to type code": "Натисніть тут, щоб ввести код вручну",
                "incorrect code": "Неправильний код",
                "scan QR code": "Відскануйте QR-код у вашому додатку",
                "six digit code": "6-значний код, згенерований вашим додатком",
                "title": "Для завершення цього процесу вам знадобиться мобільний додаток для аутентифікації, наприклад: <1>Microsoft Authenticator</1> або <2>Google Authenticator</2>.",
                "type text code": "Введіть текстовий код у вашу програму"
            },
            "settings": {
                "description": "Двофакторна автентифікація — це додатковий рівень безпеки, який перевіряє вашу особу за допомогою чогось, що ви знаєте (пароль), і чогось, що ви маєте (телефон, ключ безпеки, електронна пошта).",
                "disabled": "Вимкнено",
                "enabled": "Увімкнено",
                "title": "Двофакторна аутентифікація"
            },
            "success message": {
                "alert": "Двофакторна аутентифікація успішно активована.",
                "description": "Ми будемо запитувати код автентифікації щоразу, коли ви входитимете в систему за допомогою своєї електронної адреси та пароля.",
                "title": "Ви успішно увімкнули двофакторну автентифікацію.",
                "title modal": "Двофакторна аутентифікація увімкнена!"
            },
            "title": {
                "authentication app": "Додаток для аутентифікації",
                "authentication email": "Електронна пошта для аутентифікації",
                "is enabled": "Підтримка двофакторної аутентифікації.",
                "protect your account": "Захистіть свій обліковий запис FOTA WEB"
            }
        },
        "delete account": {
            "confirmation": {
                "account": "",
                "banner": "",
                "cancel info": "",
                "more info": "",
                "description": "",
                "title": "",
                "verification code description": {
                    "authenticator": "",
                    "email": ""
                }
            },
            "settings": {
                "description": "",
                "title": ""
            }
        },
        "password": {
            "change password": "Змінити пароль",
            "enter current password": "Введіть поточний пароль",
            "enter new password": "Введіть новий пароль",
            "hide password": "Приховати пароль",
            "repeat new password": "Повторіть новий пароль",
            "rules": {
                "lowercase letter": "Щонайменше одна мала літера (a-z)",
                "minimum characters": "Щонайменше 12 символів",
                "new and current passwords must not match": "Нові та поточні паролі не повинні збігатися",
                "new passwords must match": "Нові паролі повинні збігатися",
                "number": "Щонайменше один номер",
                "passwords must match": "Паролі повинні збігатися",
                "special symbol": "Принаймні один спеціальний символ (!@#$%^&*()-_=+)",
                "uppercase letter": "Принаймні одна велика літера (A-Z)"
            },
            "settings": {
                "description": "",
                "title": ""
            },
            "show password": "Показати пароль"
        },
        "recovery codes": {
            "banner description": "",
            "banner title": "",
            "checkbox title": "",
            "download error message": "",
            "first step description": "",
            "first step title": "",
            "input field title": "",
            "print error message": "",
            "second step description": "",
            "second step title": "",
            "settings": {
                "title": "",
                "description": ""
            }
        },
        "account": "",
        "description": "",
        "security": "",
        "security and account": ""
    },
    "Settings": {
        "version": ""
    },
    "Statistics": {
        "table statistics": "Статистика таблиць",
        "statistics message": "Фільтри таблиці впливатимуть на статистику, яку ви бачите нижче",
        "activity": "Активність",
        "model": "Модель",
        "firmware": "Прошивка",
        "configuration": "Конфігурація",
        "statistics": "Статистика"
    },
    "Table": {
        "1_wire_authorization": "1-Wire авторизація",
        "access group": "",
        "access groups": "",
        "access level": "Рівень доступу",
        "accessories": "Аксесуари",
        "action": "Дія",
        "action date": "Дата дії",
        "assigned package": "Призначений пакет",
        "attempt count": "Кількість спроб",
        "attribute": "Атрибут",
        "attributes": "Атрибути",
        "auto sync": "",
        "batch id": "Ідентифікатор партії",
        "ble_dtb": "BLE DTB",
        "ble_fw": "Прошивка BLE",
        "bluetooth_authorization": "Авторизація Bluetooth",
        "bootloader": "Завантажувач",
        "can_adapter": "Адаптер CAN",
        "can adapter name": "Назва адаптера CAN",
        "can bootstring": "Bootstring",
        "can oem file package": "Пакет файлів OEM",
        "can oem file vehicle": "OEM-файл транспортного засобу",
        "can package": "Пакет CAN",
        "can program number": "Номер програми CAN",
        "can software date": "Дані програмного забезпечення CAN",
        "can type": "Тип CAN",
        "carrier module id": "Ідентифікатор модуля",
        "carrier revision": "Ревізія",
        "carrier serial id": "Серійний ідентифікатор",
        "carrier settings filename": "Налаштування імені файлу",
        "carrier unit status": "Статус",
        "carrier unit type": "Тип одиниці",
        "changed at": "Змінено о",
        "change origin": "",
        "changes": "Зміни",
        "checkbox disabled": {
            "role": "Статичну роль не можна редагувати або видаляти."
        },
        "child company": "<0>Дочірня компанія</0><1>{{parentCompany}}</1>",
        "child companies": "Дочірні компанії",
        "code": "Код",
        "company": "Компанія",
        "company hierarchy": "Ієрархія компанії",
        "company name": "Назва компанії",
        "compatibility": "Сумісність",
        "configuration": "Конфігурація",
        "configuration details": "Деталі конфігурації",
        "configuration type": "",
        "created at": "Створено в",
        "created by": "Створено",
        "date": "Дата",
        "description": "Опис",
        "device details": "Деталі пристрою",
        "device company": "Компанія-виробник пристроїв",
        "device description": "Опис пристрою",
        "device group": "Група пристроїв",
        "device imei": "IMEI пристрою",
        "device model": "Модель пристрою",
        "device seen at": "Пристрій, побачений на",
        "device serial": "Серійний номер пристрою.",
        "devices": "Пристрої",
        "devices count": "Кількість пристроїв",
        "Done": "Готово",
        "download at": "",
        "download file": "Завантажити файл",
        "dtb": "DTB",
        "edit file": "Редагувати файл",
        "email": "Електронна пошта",
        "empty table": {
            "no initial results": {
                "description": {
                    "batches": "Як тільки групи завдань будуть створені, ви зможете переглянути їх список тут",
                    "changes": "Як тільки зміни будуть внесені, ви зможете побачити список тут",
                    "companies": "Як тільки компанії будуть створені, ви зможете переглянути їх список тут",
                    "configurationChanges": "",
                    "desktopLicenses": "Як тільки будуть створені ліцензії для desktop-комп'ютерів, ви зможете переглянути їх список тут",
                    "devices": "Як тільки пристрої будуть завантажені в FOTA WEB, ви зможете переглянути їх список тут",
                    "files": "Як тільки файли будуть завантажені, ви зможете переглянути їх список тут",
                    "groups": "Як тільки групи будуть створені, ви зможете переглянути їх список тут",
                    "offlineLicenses": "Як тільки будуть створені офлайн-ліцензії, ви зможете переглянути їх список тут",
                    "permissions": "Як тільки користувачеві будуть надані дозволи, ви зможете переглянути список тут",
                    "productCodes": "Як тільки коди продуктів будуть створені, ви зможете переглянути їх список тут",
                    "roles": "Як тільки ролі будуть створені, ви зможете переглянути їх список тут",
                    "tasks": "Як тільки завдання будуть створені, ви зможете переглянути їх список тут",
                    "users": "Як тільки користувачі будуть додані, ви зможете переглянути їх список тут"
                },
                "title": {
                    "batches": "Таблиця груп завдань порожня",
                    "changes": "Таблиця змін порожня",
                    "companies": "Таблиця компаній порожня",
                    "configurationChanges": "",
                    "desktopLicenses": "Таблиця ліцензій для desktop комп'ютерів порожня",
                    "devices": "Таблиця пристроїв порожня",
                    "files": "Таблиця файлів порожня",
                    "groups": "Таблиця груп порожня",
                    "offlineLicenses": "Таблиця офлайн-ліцензій порожня",
                    "permissions": "Таблиця дозволів порожня",
                    "productCodes": "Таблиця кодів продуктів порожня",
                    "roles": "Таблиця ролей порожня",
                    "tasks": "Таблиця завдань порожня",
                    "users": "Таблиця користувачів порожня"
                }
            },
            "no permission": {
                "description": "Зверніться до адміністратора, щоб отримати доступ.",
                "title": "Ви не маєте необхідних прав для перегляду цього вмісту"
            },
            "no results found": {
                "description": "Спробуйте інше ключове слово або фільтр, щоб отримати результати",
                "title": "Результатів не знайдено"
            },
            "button": {
                "add": {
                    "companies": "Створити компанію",
                    "devices": "Додати пристрій",
                    "files": "Завантажити файл",
                    "groups": "Створити групу",
                    "productCodes": "Додати код продукту",
                    "tasks": "Створити завдання",
                    "users": "Запросити користувача"
                },
                "reset view": "Скинути перегляд"
            }
        },
        "exausted autoscan limit": "Вичерпано ліміт автосканування до",
        "exausted vin parsing limit": "Вичерпано ліміт розбору VIN до",
        "expiration": "Термін дії",
        "expiration date": "Термін дії",
        "expires at": "Термін дії закінчується",
        "expiry date": "Термін дії",
        "field": "Поле",
        "file": "Файл",
        "file id": "Ідентифікатор файлу",
        "files": "Файли",
        "file type": "Тип файлу",
        "filter by": "Фільтрувати за",
        "firmware": "Прошивка",
        "general": "Загальна інформація",
        "general data": "Загальні дані",
        "gnss version": "Версія GNSS",
        "group": "Група",
        "groups": "Групи пристроїв",
        "group vip status": "",
        "gsm number": "Номер GSM",
        "head title info": {
            "auto synced": {
                "changed at": "",
                "download at": "",
                "synced at": "",
                "user sent configuration": ""
            },
            "platform": {
                "fmx platform": "Платформа FMx - моделі FMx (FMB, FMU, FMC, FMM), FMT, FMP, TAT, MSP, TFT, TST, GH (GH5200) та TMT.",
                "ft platform": "Платформа FT - моделі FTx та ATx.",
                "legacy platform": "<1>Застаріла платформа</1> — моделі FM (крім FM4001 і FM3010), FMA і GH (GH4000).",
                "title": "Платформа для створення телематичних пристроїв"
            },
            "visibility": "Зміни, позначені як <1>Внутрішні</1>, не відображаються клієнтам. Оскільки зміни пристроїв можуть включати як видимі, так і приховані дані, <1>не діліться скріншотами або деталями у зовнішніх комунікаціях</1>"
        },
        "iccid": "ICCID",
        "id": "ID",
        "imei": "IMEI",
        "imsi": "IMSI",
        "info": "Інформація",
        "interface": "Інтерфейс",
        "invited by": "Запрошено",
        "items": "елементи",
        "last checked at": "Останнє перевірка:",
        "last sign in": "Останній вхід",
        "last status update": "Останнє оновлення статусу",
        "last used at": "Останнє використання",
        "license disabled": "Вимкнено",
        "license enabled": "Увімкнено",
        "license key": "Ліцензійний ключ",
        "license name": "",
        "links": "Посилання",
        "manual_geofence_scenarios": "Сценарії ручного геофенсінгу",
        "message": "Повідомлення",
        "model": "Модель",
        "model task type support": {
            "false": "Не підтримується",
            "true": "Підтримується"
        },
        "modem version": "Версія для модему",
        "name": "Назва",
        "new value": "Нова цінність",
        "next task": "Наступне завдання",
        "no changes": "Без змін.",
        "no company name": "Назва компанії не вказана",
        "no details": "Без деталей",
        "no file": "Без файлів",
        "no imei available": "IMEI недоступний",
        "no model": "Без моделі",
        "no parent company": "Компанія не має материнської компанії.",
        "no tasks": "Пристрій не має завдань.",
        "number": "Номер",
        "obd": "OBD",
        "obd chip firmware version": "Версія прошивки чіпа OBD",
        "of": "з",
        "offline licenses tab disabled": "Офлайн-ліцензії не доступні для вимкнених ліцензій для desktop-комп'ютерів.",
        "origin": "",
        "original value": "Оригінальна цінність",
        "other information": "Інша інформація",
        "page of": "сторінка",
        "parent company": "Материнська компанія",
        "permission count": "Кількість дозволів",
        "platform": "Платформа",
        "Price": "Ціна",
        "product code": "Код продукту",
        "program number": "Номер програми",
        "property": "Власність",
        "queue": "Черга",
        "receiving company": "Компанія-одержувач",
        "revision": "Ревізія",
        "role": "Роль",
        "role name": "Назва ролі",
        "rows per page": "Рядки на сторінці",
        "running": "Працює",
        "schedule": "Розклад",
        "seen at": "Останнє підключення",
        "select row": "Виберіть рядок, щоб переглянути деталі",
        "send sms": "Відправлення SMS",
        "serial": "Серійний номер.",
        "show details": {
            "desktopLicenses": "Показати деталі ліцензії для desktop комп'ютерів",
            "devices": "Показати деталі пристрою",
            "batches": "Показати деталі групи завдань",
            "tasks": "Показати деталі завдання",
            "companies": "Показати детальну інформацію про компанію"
        },
        "sim": "SIM",
        "size": "Розмір",
        "software date": "Дата програмного забезпечення",
        "source company": "Вихідна компанія",
        "spec_id": "Spec ID",
        "status": "Статус",
        "status id": "Ідентифікатор статусу",
        "status name": "Назва статусу",
        "supported task types": "Підтримувані типи завдань",
        "synced at": "",
        "sync mode": "",
        "sync status": "",
        "table columns": "Столбцы таблицы",
        "target company": "Цільова компанія",
        "task id": "Ідентифікатор завдання",
        "task queue": "Черга завдань",
        "tasks": "Завдання",
        "task type": "Тип завдання",
        "tct web support": "TCT web-підтримка",
        "total": "Загалом",
        "type": "Тип",
        "updated at": "Оновлено",
        "updated by": "Оновлено",
        "unknown": "Невідомо",
        "user cannot be deleted": "Користувача не можна видалити.",
        "user cannot be edited": "Користувач не може бути відредагований.",
        "user cannot delete himself": "Користувач не може видалити власний профіль.",
        "user date statuses": {
            "expired": "Термін дії закінчився",
            "expires": "Термін дії закінчується",
            "never expires": "Не має терміну дії",
            "sent": "Надіслано"
        },
        "user email": "Електронна пошта користувача",
        "user invitation cannot be cancelled": "Запрошення користувача не можна скасувати.",
        "user invitation cannot be resent": "Запрошення користувача не можна надіслати повторно.",
        "user sent configuration": "",
        "user statuses": {
            "Active": "Активний",
            "Inactive": "Неактивних",
            "InvitationExpired": "Запрошення, термін дії якого закінчився",
            "InvitationPending": "Очікування запрошення"
        },
        "users": "Користувачі",
        "value from": "Цінність від",
        "value to": "Цінність для",
        "view all roles": "Переглянути все ({{count}})",
        "vin": "VIN",
        "vip status": "VIP-статус",
        "visibility": "Видимість"
    },
    "Table details": {
        "bluetooth password": {
            "aria label unknown tooltip": "",
            "disabled copy tooltip": "",
            "unknown": "",
            "unknown tooltip": ""
        },
        "device details": {
            "configuration": {
                "badge tooltips": {
                    "not supported": "",
                    "sync failed": "",
                    "syncing": ""
                },
                "configuration details": "",
                "mode descriptions": {
                    "Disabled": "",
                    "Enabled": "",
                    "ReportingOnly": ""
                },
                "mode not supported tooltip": "",
                "mode titles": {
                    "Disabled": "",
                    "Enabled": "",
                    "not supported": "",
                    "ReportingOnly": ""
                },
                "overview": "",
                "status titles": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "status tooltips": {
                    "cancelled": "",
                    "completed": "",
                    "failed": "",
                    "syncing": ""
                },
                "sync history": "",
                "sync status": ""
            }
        },
        "device group tasks": "",
        "group tasks": "",
        "number of devices": "",
        "permissions info": "Інформація про дозволи",
        "smart group files": "",
        "tooltip info": {
            "devices": {
                "accessories": {
                    "interface": "Назва інтерфейсу аксесуара.",
                    "type": "тип підключеного аксесуара."
                },
                "can": {
                    "assigned package": "пакет OEM, призначений для пристрою.",
                    "can oem file package": "пакет OEM, про який повідомлялося під час останнього підключення.",
                    "can oem file vehicle": "Конфігурація OEM-транспортного засобу, повідомлена під час останнього підключення.",
                    "dtb": "",
                    "firmware": "версія прошивки CAN."
                },
                "can_adapter": {
                    "can adapter name": "",
                    "can bootstring": "останній отриманий стартовий рядок CAN-адаптера, що містить поточні дані та номер програми адаптера.",
                    "program number": "номер програми CAN-адаптера.",
                    "revision": "",
                    "software date": "Дата програмного забезпечення адаптера CAN.",
                    "type": "тип CAN-адаптера."
                },
                "configuration overview": {
                    "BluetoothAuthorizationList": "",
                    "MainConfiguration": "",
                    "ManualGeofenceList": "",
                    "OneWireAuthorizationList": ""
                },
                "configuration details": {
                    "1_wire_authorization": "останній надісланий файл із списком авторизацій 1-Wire.",
                    "bluetooth_authorization": "останнє надіслане ім'я файлу списку авторизації Bluetooth.",
                    "main configuration": "останнє надіслане ім'я головного файлу конфігурації.",
                    "manual_geofence_scenarios": "Останній надісланий файл із переліком геозони."
                },
                "general": {
                    "ble_dtb": "",
                    "ble_fw": "версія прошивки BLE, про яку повідомлялося під час останнього підключення.",
                    "bluetooth password": "",
                    "bootloader": "версія завантажувача пристрою, про яку було повідомлено під час останнього підключення.",
                    "company": "компанія, яка володіє цим пристроєм.",
                    "configuration": "назва останнього надісланого файлу конфігурації.",
                    "description": "опис пристрою (визначається користувачем).",
                    "dtb": "версія дерева пристроїв, про яку повідомлялося під час останнього підключення.",
                    "firmware": "версія прошивки пристрою, про яку повідомлялося під час останнього підключення.",
                    "gnss version": "версія GNSS, повідомлена під час останнього підключення.",
                    "group": "група пристроїв, до якої належить цей пристрій.",
                    "product code": "Код продукту пристрою.",
                    "serial": "серійний номер пристрою."
                },
                "obd": {
                    "obd chip firmware version": "версія прошивки чіпа OBD, про яку повідомлялося під час останнього підключення.",
                    "vin": "унікальний 17-значний код, що ідентифікує конкретний автомобіль."
                },
                "sim": {
                    "gsm number": "публічний телефонний номер, пов'язаний з пристроєм.",
                    "iccid": "унікальний серійний номер, що ідентифікує SIM-карту.",
                    "imsi": "унікальний ідентифікатор абонента мобільної мережі."
                }
            },
            "groups": {
                "fmx platform files": {
                    "configuration": "",
                    "firmware": ""
                },
                "ft platform files": {
                    "1_wire_authorization_list": "",
                    "bluetooth_authorization_list": "",
                    "firmware": "",
                    "main configuration": ""
                }
            },
            "users": {
                "general": {
                    "created at": "дата і час створення користувача.",
                    "id": "унікальний ідентифікатор користувача.",
                    "invited by": "адреса електронної пошти користувача, який створив запрошення.",
                    "role": "ролі, призначені користувачеві.",
                    "updated at": "дата та час останнього оновлення користувачем."
                }
            }
        },
        "user details": "Дані користувача"
    },
    "Task groups": {
        "all": "Все",
        "bulk type": {
            "CompanyBulkDelete": "Видалити компанію",
            "DeviceBulkCreate": "Додати пристрій",
            "DeviceBulkDelete": "Видалити пристрій",
            "DeviceBulkUpdate": "Оновлення пристрою",
            "FileBulkDelete": "Видалити файл",
            "GroupBulkDelete": "Видалити групу",
            "TaskBulkCreate": "Створити завдання",
            "TaskBulkUpdate": "Скасувати завдання",
            "UserBulkDelete": "Видалити користувача"
        },
        "pending approval": "Очікується затвердження",
        "already approved": "Вже затверджено",
        "no approval required": "Не потрібно затвердження",
        "total objects": "Загальна кількість об'єктів",
        "total tasks": "Загальна кількість завдань"
    },
    "Task status": {
        "0": "В очікуванні",
        "1": "Працює",
        "2": "Завершено",
        "3": "Завершено з помилками",
        "4": "Скасовано",
        "5": "Не вдалося",
        "6": "Термін дії закінчився",
        "7": "Очікує на затвердження",
        "8": "Перевірка",
        "task count": {
            "0": "Завдання, що очікують на виконання",
            "1": "Виконання завдань",
            "3": "Виконані завдання з помилками",
            "5": "Неуспішні завдання"
        },
        "verified tooltip title": "Завдання було успішно виконано та перевірено пристроєм."
    },
    "Tasks": {
        "0": "Завдання знаходиться в черзі і зараз очікує виконання.",
        "1": "Завдання наразі виконується.",
        "2": "Завдання було успішно виконано.",
        "3": "Завдання виконано, але виникли деякі помилки.",
        "4": "Завдання було скасовано.",
        "5": "Завдання не виконано.",
        "6": "Завдання не було виконано в установлений термін."
    },
    "Tct": {
        "edit configuration": "Редагування конфігурації",
        "no editable configurations": "Не завантажуються редаговані конфігурації",
        "open tct": "Відкрити TCT web-версію",
        "open tct description": "Виберіть створення нової конфігурації у TCT web або редагування існуючого файлу конфігурації з FOTA WEB.",
        "select configuration file": "Виберіть файл конфігурації, який ви хочете редагувати в TCT web.",
        "tct web": "TCT web",
        "tct web disabled description": "TCT web доступна тільки для компаній рівня Premium."
    },
    "Tutorial": {
        "buttons": {
            "exit": "",
            "finish": "",
            "get started": "",
            "next": "",
            "next feature": ""
        },
        "content": {
            "company selector": {
                "0": "",
                "1": "",
                "1-info": ""
            },
            "finish tutorial": "",
            "first time user": "",
            "task groups": {
                "desktop": {
                    "0": "",
                    "1": ""
                },
                "mobile": {
                    "0": "",
                    "1": ""
                }
            }
        },
        "titles": {
            "finish tutorial": "",
            "first time user": "",
            "tutorial mode": ""
        }
    }
}
